import { Container } from "./styles";
import externalLink from "../../assets/external-link.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function Experience() {
  return (
    <Container id="experience">
      <h2>My Experience</h2>
      <div className="projects">
        <ScrollAnimation animateIn="fadeIn" duration={3}>
          <div className="project">
            <header>
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="50"
                viewBox="0 0 132 132"
                enableBackground="new 0 0 132 132"
              >
                <path
                  fill="#0170EB"
                  opacity="1.000000"
                  stroke="none"
                  d="
M133.000000,29.000000 
	C133.000000,54.020893 133.000000,79.041786 132.678558,104.727036 
	C130.859116,109.145050 129.829285,113.180763 127.771179,116.596992 
	C122.576767,125.219116 114.542557,130.238144 105.000000,133.000000 
	C79.979103,133.000000 54.958210,133.000000 29.272964,132.678558 
	C24.854956,130.859116 20.819241,129.829300 17.403017,127.771179 
	C8.780900,122.576767 3.761807,114.542587 1.000000,105.000000 
	C1.000000,79.979103 1.000000,54.958210 1.321435,29.272963 
	C3.140879,24.854952 4.170714,20.819241 6.228818,17.403013 
	C11.423219,8.780871 19.457436,3.761842 29.000000,1.000000 
	C54.020893,1.000000 79.041786,1.000000 104.727036,1.321434 
	C109.145050,3.140876 113.180756,4.170708 116.596985,6.228817 
	C125.219116,11.423225 130.238159,19.457430 133.000000,29.000000 
M68.815514,88.293251 
	C66.833138,92.174469 64.850761,96.055679 62.788757,100.092796 
	C68.970757,101.712982 72.725800,100.807877 75.104507,95.040504 
	C77.944389,88.154991 81.615768,81.589005 85.252090,75.065842 
	C86.923820,72.066956 86.725998,69.668419 85.152878,66.770432 
	C81.509750,60.059105 78.179008,53.178898 74.669312,46.394222 
	C71.532478,40.330360 70.347511,39.890999 63.060135,42.085823 
	C66.546600,48.919392 69.570862,55.960152 73.584427,62.382671 
	C77.184830,68.144043 77.613396,73.151871 73.669441,78.765915 
	C71.780251,81.455093 70.613762,84.651993 68.815514,88.293251 
M47.094086,113.967560 
	C48.602413,112.740646 50.692223,111.820229 51.526279,110.237907 
	C57.716660,98.493866 63.666489,86.622841 69.661972,74.776573 
	C70.216728,73.680466 70.563461,72.479080 71.051651,71.209946 
	C62.040516,70.569733 62.039551,70.569244 58.273342,78.052193 
	C52.899212,88.729836 47.516628,99.403259 42.168579,110.093964 
	C41.619743,111.191086 41.281525,112.393570 40.686256,113.968758 
	C42.937313,113.968758 44.589981,113.968758 47.094086,113.967560 
M74.345398,34.238926 
	C79.561203,44.431694 84.777016,54.624462 90.018303,64.867020 
	C95.367226,59.295311 94.962639,54.235943 91.363091,48.389858 
	C87.286034,41.768250 84.138275,34.575439 80.568336,27.640316 
	C77.036667,20.779556 76.385071,20.500208 68.468971,22.461380 
	C70.336487,26.196949 72.178932,29.882376 74.345398,34.238926 
z"
                />
                <path
                  fill="#47704C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M28.531342,1.000000 
	C19.457436,3.761842 11.423219,8.780871 6.228818,17.403013 
	C4.170714,20.819241 3.140879,24.854952 1.321435,28.804306 
	C1.000000,19.740208 1.000000,10.480416 1.000000,1.000000 
	C10.019698,1.000000 19.041191,1.000000 28.531342,1.000000 
z"
                />
                <path
                  fill="#47704C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M133.000000,28.531342 
	C130.238159,19.457430 125.219116,11.423225 116.596985,6.228817 
	C113.180756,4.170708 109.145050,3.140876 105.195694,1.321434 
	C114.259789,1.000000 123.519585,1.000000 133.000000,1.000000 
	C133.000000,10.019698 133.000000,19.041191 133.000000,28.531342 
z"
                />
                <path
                  fill="#47704C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M1.000000,105.468658 
	C3.761807,114.542587 8.780900,122.576767 17.403017,127.771179 
	C20.819241,129.829300 24.854956,130.859116 28.804308,132.678558 
	C19.740210,133.000000 10.480418,133.000000 1.000000,133.000000 
	C1.000000,123.980301 1.000000,114.958809 1.000000,105.468658 
z"
                />
                <path
                  fill="#47704C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M105.468658,133.000000 
	C114.542557,130.238144 122.576767,125.219116 127.771179,116.596992 
	C129.829285,113.180763 130.859116,109.145050 132.678558,105.195694 
	C133.000000,114.259789 133.000000,123.519585 133.000000,133.000000 
	C123.980301,133.000000 114.958809,133.000000 105.468658,133.000000 
z"
                />
                <path
                  fill="#94C3F7"
                  opacity="1.000000"
                  stroke="none"
                  d="
M68.967743,87.956100 
	C70.613762,84.651993 71.780251,81.455093 73.669441,78.765915 
	C77.613396,73.151871 77.184830,68.144043 73.584427,62.382671 
	C69.570862,55.960152 66.546600,48.919392 63.060135,42.085823 
	C70.347511,39.890999 71.532478,40.330360 74.669312,46.394222 
	C78.179008,53.178898 81.509750,60.059105 85.152878,66.770432 
	C86.725998,69.668419 86.923820,72.066956 85.252090,75.065842 
	C81.615768,81.589005 77.944389,88.154991 75.104507,95.040504 
	C72.725800,100.807877 68.970757,101.712982 62.788757,100.092796 
	C64.850761,96.055679 66.833138,92.174469 68.967743,87.956100 
z"
                />
                <path
                  fill="#F8FBFF"
                  opacity="1.000000"
                  stroke="none"
                  d="
M46.668365,113.968155 
	C44.589981,113.968758 42.937313,113.968758 40.686256,113.968758 
	C41.281525,112.393570 41.619743,111.191086 42.168579,110.093964 
	C47.516628,99.403259 52.899212,88.729836 58.273342,78.052193 
	C62.039551,70.569244 62.040516,70.569733 71.051651,71.209946 
	C70.563461,72.479080 70.216728,73.680466 69.661972,74.776573 
	C63.666489,86.622841 57.716660,98.493866 51.526279,110.237907 
	C50.692223,111.820229 48.602413,112.740646 46.668365,113.968155 
z"
                />
                <path
                  fill="#F8FBFE"
                  opacity="1.000000"
                  stroke="none"
                  d="
M74.183388,33.903366 
	C72.178932,29.882376 70.336487,26.196949 68.468971,22.461380 
	C76.385071,20.500208 77.036667,20.779556 80.568336,27.640316 
	C84.138275,34.575439 87.286034,41.768250 91.363091,48.389858 
	C94.962639,54.235943 95.367226,59.295311 90.018303,64.867020 
	C84.777016,54.624462 79.561203,44.431694 74.183388,33.903366 
z"
                />
              </svg>
              <p style={{ fontWeight: "bold", fontSize: "2rem" }}>Warba Bank</p>
              <div className="project-links">
                <a
                  href="https://www.warbabank.com/english/personal"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </header>
            <div className="body">
              <h3>Software Engineer</h3>
              <p>
                {" "}
                I'm working as a software engineer specializing in frontend
                development with React and Module Federation to enhance internal
                admin services. Additionally, I contributed to backend
                development using Java and microservices architecture,
                implementing a Maker/Checker approach to ensure secure and
                efficient transaction processing.{" "}
              </p>
            </div>
            <footer>
              {" "}
              <ul className="tech-list">
                {" "}
                <li>March 12, 2023</li> <li>⟶</li> <li>Present</li>{" "}
              </ul>{" "}
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn" duration={3}>
          <div className="project">
            <header>
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="50"
                viewBox="0 0 200 200"
                enableBackground="new 0 0 200 200"
              >
                <path
                  fill="#FDFEFE"
                  opacity="1.000000"
                  stroke="none"
                  d="
M100.000000,201.000000 
	C67.035065,201.000000 34.070129,201.000000 1.052597,201.000000 
	C1.052597,134.439270 1.052597,67.878494 1.052597,1.000000 
	C38.353626,1.000000 75.708153,1.000000 113.704605,1.249826 
	C114.916039,1.672062 115.485558,1.844473 116.052696,2.356574 
	C115.989151,3.143327 115.927986,3.590389 115.597473,4.337798 
	C115.215385,10.671064 115.040070,16.703602 115.003365,22.736984 
	C114.934387,34.074146 114.963356,45.411877 114.911316,56.749191 
	C114.897499,59.758862 113.074722,60.357544 110.546120,59.698143 
	C108.659653,59.206200 106.801048,58.607449 104.967285,58.035282 
	C105.004547,58.014305 104.948807,58.079315 104.932922,57.758308 
	C103.964294,57.197979 103.011566,56.958660 101.678276,56.748344 
	C100.542496,56.881580 99.787277,56.985817 98.862930,56.843952 
	C98.164520,57.112408 97.635231,57.626965 97.063599,58.111588 
	C97.021240,58.081661 97.124962,58.082405 96.879730,58.144081 
	C96.424423,58.459881 96.214348,58.714008 95.874893,59.063232 
	C95.745506,59.158333 95.424728,59.174049 95.125519,59.198814 
	C94.557037,59.500793 94.287773,59.778008 93.854691,60.272671 
	C93.190819,60.685059 92.690765,60.879993 91.942116,61.116863 
	C91.465584,61.393723 91.237640,61.628651 90.857681,61.973328 
	C90.705673,62.083080 90.335556,62.143250 90.053543,62.173851 
	C89.513023,62.465519 89.254524,62.726585 88.997849,62.994274 
	C88.999680,63.000893 88.987465,62.992493 88.680679,63.006165 
	C87.929100,63.384640 87.484306,63.749439 86.822571,64.371605 
	C80.717865,68.061874 74.723839,71.331276 69.015816,75.040756 
	C67.558662,75.987724 66.209663,78.310173 66.169556,80.032288 
	C65.910179,91.171478 65.906212,102.321991 66.144310,113.461838 
	C66.182175,115.233543 67.407242,117.719452 68.857925,118.601746 
	C78.512436,124.473557 88.307541,130.128525 98.245987,135.504517 
	C99.830482,136.361618 102.744293,136.157410 104.398750,135.257904 
	C113.741432,130.178436 122.804619,124.584930 132.146912,119.504707 
	C135.257263,117.813332 136.122574,115.798889 136.109238,112.432877 
	C135.991943,82.823997 135.805115,53.211147 136.215607,23.607466 
	C136.316345,16.343697 135.609833,10.607874 127.858154,7.682606 
	C127.408104,7.338376 127.092636,7.215760 126.564972,7.064466 
	C126.352776,7.035789 125.985886,6.814913 125.866837,6.618898 
	C125.527084,6.185646 125.254921,6.058241 124.965790,6.025569 
	C125.000275,6.010469 124.954819,6.070506 124.911667,5.698051 
	C123.799995,4.940912 122.731476,4.556226 121.477875,4.133162 
	C121.292793,4.094782 120.993286,3.864121 120.860191,3.652009 
	C120.423676,3.317021 120.120247,3.194146 119.604218,3.041577 
	C119.391617,3.011883 119.029236,2.781618 119.027023,2.484634 
	C119.016533,1.791766 119.008263,1.395883 119.000000,1.000000 
	C146.301926,1.000000 173.603836,1.000000 200.952881,1.000000 
	C200.952881,67.558609 200.952881,134.117249 200.952881,201.000000 
	C168.313156,201.000000 135.625229,201.000000 102.631454,200.699554 
	C104.182121,199.289749 106.025589,198.157791 107.897148,197.074356 
	C134.251190,181.818619 160.635422,166.614487 186.907852,151.219528 
	C188.700272,150.169220 190.823013,147.707642 190.835922,145.888535 
	C191.068665,113.084984 191.012482,80.279282 190.945023,47.474182 
	C190.942612,46.301655 190.547607,44.555557 189.732544,44.051075 
	C183.860947,40.416866 177.833527,37.034420 170.970627,33.059650 
	C170.970627,35.933403 170.970642,37.696175 170.970612,39.458950 
	C170.970184,70.432419 170.909683,101.406166 171.050293,132.378998 
	C171.066650,135.982513 170.029633,138.041046 166.832794,139.859344 
	C146.438309,151.459290 126.109650,163.179062 105.915512,175.123444 
	C102.206177,177.317444 99.543419,177.069458 95.971573,174.962997 
	C81.509956,166.434341 66.859024,158.226685 52.087379,149.634979 
	C50.927670,148.916229 49.958519,148.463074 48.994606,148.004944 
	C48.999847,148.000000 48.991596,148.010986 48.821533,147.767731 
	C48.107697,147.318329 47.563919,147.112183 47.019379,146.943619 
	C47.018616,146.981186 47.085915,146.947739 46.923302,146.688171 
	C46.194073,146.222427 45.627449,146.016266 45.061584,145.860596 
	C45.062347,145.911072 45.157246,145.876556 45.002228,145.607361 
	C44.272644,145.130417 43.698078,144.922668 43.109741,144.787354 
	C43.095970,144.859756 43.241428,144.835800 43.139439,144.576096 
	C42.696411,144.193512 42.355373,144.070633 42.011482,143.975891 
	C42.008625,144.004013 42.053986,143.970230 41.874786,143.727295 
	C41.141003,143.280289 40.586411,143.076218 40.037342,142.912292 
	C40.042866,142.952438 40.117935,142.921890 40.000359,142.682281 
	C39.260345,142.137756 38.637913,141.832825 37.783020,141.336411 
	C37.354706,141.100739 37.158852,141.056549 36.798691,140.769241 
	C36.094891,140.327423 35.555397,140.128723 35.013065,139.963364 
	C35.010227,139.996704 35.066635,139.960693 34.886322,139.700592 
	C33.476524,138.623779 32.247040,137.807053 31.008823,136.994858 
	C31.000095,136.999390 31.015476,136.985428 31.057795,136.519730 
	C31.150324,109.388206 31.200533,82.722389 31.577660,55.968060 
	C47.024246,47.140015 62.167530,38.440697 77.227768,29.599901 
	C78.765778,28.697048 80.821541,27.003994 80.903549,25.577938 
	C81.291412,18.833050 81.076622,12.053506 81.076622,4.615184 
	C79.154579,5.557355 77.826714,6.115201 76.588745,6.828978 
	C56.126801,18.626841 35.717369,30.516880 15.180016,42.181755 
	C11.976528,44.001282 11.003542,46.068905 11.020523,49.661240 
	C11.168439,80.953018 11.189609,112.246277 11.005427,143.537674 
	C10.981752,147.559967 12.215309,149.774704 15.676044,151.743668 
	C37.938168,164.409607 60.101398,177.250076 82.250023,190.114304 
	C88.250107,193.599243 94.087776,197.363800 100.000000,201.000000 
z"
                />
                <path
                  fill="#436BDB"
                  opacity="1.000000"
                  stroke="none"
                  d="
M52.277946,149.900574 
	C66.859024,158.226685 81.509956,166.434341 95.971573,174.962997 
	C99.543419,177.069458 102.206177,177.317444 105.915512,175.123444 
	C126.109650,163.179062 146.438309,151.459290 166.832794,139.859344 
	C170.029633,138.041046 171.066650,135.982513 171.050293,132.378998 
	C170.909683,101.406166 170.970184,70.432419 170.970612,39.458950 
	C170.970642,37.696175 170.970627,35.933403 170.970627,33.059650 
	C177.833527,37.034420 183.860947,40.416866 189.732544,44.051075 
	C190.547607,44.555557 190.942612,46.301655 190.945023,47.474182 
	C191.012482,80.279282 191.068665,113.084984 190.835922,145.888535 
	C190.823013,147.707642 188.700272,150.169220 186.907852,151.219528 
	C160.635422,166.614487 134.251190,181.818619 107.897148,197.074356 
	C106.025589,198.157791 104.182121,199.289749 102.162796,200.699554 
	C101.555557,201.000000 101.111107,201.000000 100.333328,201.000000 
	C94.087776,197.363800 88.250107,193.599243 82.250023,190.114304 
	C60.101398,177.250076 37.938168,164.409607 15.676044,151.743668 
	C12.215309,149.774704 10.981752,147.559967 11.005427,143.537674 
	C11.189609,112.246277 11.168439,80.953018 11.020523,49.661240 
	C11.003542,46.068905 11.976528,44.001282 15.180016,42.181755 
	C35.717369,30.516880 56.126801,18.626841 76.588745,6.828978 
	C77.826714,6.115201 79.154579,5.557355 81.076622,4.615184 
	C81.076622,12.053506 81.291412,18.833050 80.903549,25.577938 
	C80.821541,27.003994 78.765778,28.697048 77.227768,29.599901 
	C62.167530,38.440697 47.024246,47.140015 31.223797,56.202972 
	C30.360542,57.487057 30.019817,58.447536 30.018705,59.408413 
	C29.990196,84.045837 29.982616,108.683350 30.041189,133.320663 
	C30.044096,134.543030 30.676296,135.763870 31.015476,136.985428 
	C31.015476,136.985428 31.000095,136.999390 31.013432,137.381500 
	C32.373390,138.495956 33.720013,139.228317 35.066635,139.960693 
	C35.066635,139.960693 35.010227,139.996704 35.158947,140.224670 
	C35.859444,140.639221 36.411221,140.825790 36.962997,141.012360 
	C37.158852,141.056549 37.354706,141.100739 37.859711,141.609222 
	C38.818554,142.356293 39.468246,142.639084 40.117935,142.921875 
	C40.117935,142.921890 40.042866,142.952438 40.181793,143.190247 
	C40.898476,143.608765 41.476231,143.789505 42.053986,143.970230 
	C42.053986,143.970230 42.008625,144.004013 42.134430,144.219116 
	C42.587296,144.568069 42.914360,144.701935 43.241425,144.835815 
	C43.241428,144.835800 43.095970,144.859756 43.219212,145.102127 
	C43.947384,145.521851 44.552315,145.699203 45.157246,145.876556 
	C45.157246,145.876556 45.062347,145.911072 45.191795,146.154572 
	C45.909466,146.581299 46.497692,146.764526 47.085915,146.947739 
	C47.085915,146.947739 47.018616,146.981186 47.164803,147.210876 
	C47.871189,147.630707 48.431393,147.820847 48.991596,148.010986 
	C48.991596,148.010986 48.999847,148.000000 49.059120,148.366623 
	C50.171577,149.122360 51.224762,149.511475 52.277946,149.900574 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M118.583336,1.000000 
	C119.008263,1.395883 119.016533,1.791766 118.718094,2.453998 
	C117.625954,2.485858 116.840515,2.251370 116.055077,2.016882 
	C115.485558,1.844473 114.916039,1.672062 114.173264,1.249826 
	C115.388893,1.000000 116.777779,1.000000 118.583336,1.000000 
z"
                />
                <path
                  fill="#46C9C1"
                  opacity="1.000000"
                  stroke="none"
                  d="
M116.052696,2.356573 
	C116.840515,2.251370 117.625954,2.485858 118.720314,2.750982 
	C119.029236,2.781618 119.391617,3.011883 119.733040,3.260455 
	C120.380737,3.627392 120.687012,3.745757 120.993286,3.864121 
	C120.993286,3.864121 121.292793,4.094782 121.674820,4.397883 
	C123.022835,5.157491 123.988831,5.613998 124.954819,6.070505 
	C124.954819,6.070506 125.000275,6.010469 125.066467,6.242560 
	C125.352913,6.748985 125.637321,6.862405 125.985886,6.814913 
	C125.985886,6.814913 126.352776,7.035789 126.704865,7.284401 
	C127.368881,7.656750 127.680801,7.780486 127.992722,7.904221 
	C135.609833,10.607874 136.316345,16.343697 136.215607,23.607466 
	C135.805115,53.211147 135.991943,82.823997 136.109238,112.432877 
	C136.122574,115.798889 135.257263,117.813332 132.146912,119.504707 
	C122.804619,124.584930 113.741432,130.178436 104.398750,135.257904 
	C102.744293,136.157410 99.830482,136.361618 98.245987,135.504517 
	C88.307541,130.128525 78.512436,124.473557 68.857925,118.601746 
	C67.407242,117.719452 66.182175,115.233543 66.144310,113.461838 
	C65.906212,102.321991 65.910179,91.171478 66.169556,80.032288 
	C66.209663,78.310173 67.558662,75.987724 69.015816,75.040756 
	C74.723839,71.331276 80.717865,68.061874 87.118607,64.336784 
	C88.083534,63.693901 88.535500,63.343197 88.987465,62.992493 
	C88.987465,62.992493 88.999680,63.000893 89.272522,62.949303 
	C89.808769,62.646225 90.072159,62.394737 90.335556,62.143250 
	C90.335556,62.143250 90.705673,62.083080 91.109238,61.942253 
	C91.738770,61.559258 91.964737,61.317093 92.190704,61.074928 
	C92.690765,60.879993 93.190819,60.685059 94.138626,60.219028 
	C94.865822,59.689976 95.145279,59.432014 95.424728,59.174049 
	C95.424728,59.174049 95.745506,59.158333 96.131493,59.021255 
	C96.719971,58.616920 96.922462,58.349659 97.124954,58.082405 
	C97.124962,58.082405 97.021240,58.081661 97.352158,58.081223 
	C98.132736,57.750538 98.582397,57.420296 99.032051,57.090054 
	C99.787277,56.985817 100.542496,56.881580 101.928955,56.958725 
	C103.356392,57.453175 104.152596,57.766243 104.948807,58.079315 
	C104.948807,58.079315 105.004547,58.014305 105.133087,58.332611 
	C108.604279,60.647461 111.946922,62.644009 115.866821,64.985352 
	C115.866821,44.033131 115.866821,24.035292 115.866821,4.037452 
	C115.927986,3.590389 115.989151,3.143327 116.052696,2.356573 
M115.753227,88.473213 
	C112.119255,86.185371 108.411140,84.005379 104.875320,81.574760 
	C102.160339,79.708420 99.958763,80.436684 97.077866,81.554382 
	C87.856850,85.131859 84.086548,91.371201 86.050751,101.072319 
	C86.147614,101.550735 85.894608,102.149765 86.093262,102.548935 
	C86.840179,104.049767 87.357140,105.991547 88.596519,106.857384 
	C91.847313,109.128433 95.362556,111.062706 98.925644,112.820625 
	C100.055618,113.378128 101.850601,113.399734 103.032578,112.914566 
	C115.202034,107.919289 116.007675,106.657295 116.005493,93.773514 
	C116.005241,92.279991 115.972473,90.786461 115.753227,88.473213 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M115.597473,4.337798 
	C115.866821,24.035292 115.866821,44.033131 115.866821,64.985352 
	C111.946922,62.644009 108.604279,60.647461 105.095833,58.353584 
	C106.801048,58.607449 108.659653,59.206200 110.546120,59.698143 
	C113.074722,60.357544 114.897499,59.758862 114.911316,56.749191 
	C114.963356,45.411877 114.934387,34.074146 115.003365,22.736984 
	C115.040070,16.703602 115.215385,10.671064 115.597473,4.337798 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M31.057793,136.519730 
	C30.676296,135.763870 30.044096,134.543030 30.041189,133.320663 
	C29.982616,108.683350 29.990196,84.045837 30.018705,59.408413 
	C30.019817,58.447536 30.360542,57.487057 30.896883,56.291477 
	C31.200533,82.722389 31.150324,109.388206 31.057793,136.519730 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M34.886322,139.700592 
	C33.720013,139.228317 32.373390,138.495956 31.022160,137.376953 
	C32.247040,137.807053 33.476524,138.623779 34.886322,139.700592 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M52.087379,149.634979 
	C51.224762,149.511475 50.171577,149.122360 49.053879,148.371582 
	C49.958519,148.463074 50.927670,148.916229 52.087379,149.634979 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M104.932922,57.758308 
	C104.152596,57.766243 103.356392,57.453175 102.309509,56.929722 
	C103.011566,56.958660 103.964294,57.197979 104.932922,57.758308 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M124.911667,5.698050 
	C123.988831,5.613998 123.022835,5.157491 121.859894,4.436263 
	C122.731476,4.556226 123.799995,4.940912 124.911667,5.698050 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M98.862930,56.843952 
	C98.582397,57.420296 98.132736,57.750538 97.394516,58.111149 
	C97.635231,57.626965 98.164520,57.112408 98.862930,56.843952 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M40.000359,142.682281 
	C39.468246,142.639084 38.818554,142.356293 38.092171,141.800690 
	C38.637913,141.832825 39.260345,142.137756 40.000359,142.682281 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M48.821533,147.767731 
	C48.431393,147.820847 47.871189,147.630707 47.165562,147.173309 
	C47.563919,147.112183 48.107697,147.318329 48.821533,147.767731 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M46.923302,146.688171 
	C46.497692,146.764526 45.909466,146.581299 45.191032,146.104095 
	C45.627449,146.016266 46.194073,146.222427 46.923302,146.688171 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M45.002228,145.607361 
	C44.552315,145.699203 43.947384,145.521851 43.232979,145.029724 
	C43.698078,144.922668 44.272644,145.130417 45.002228,145.607361 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M88.680679,63.006165 
	C88.535500,63.343197 88.083534,63.693901 87.335541,64.079422 
	C87.484306,63.749439 87.929100,63.384640 88.680679,63.006165 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M41.874786,143.727295 
	C41.476231,143.789505 40.898476,143.608765 40.176270,143.150085 
	C40.586411,143.076218 41.141003,143.280289 41.874786,143.727295 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M36.798691,140.769241 
	C36.411221,140.825790 35.859444,140.639221 35.161785,140.191345 
	C35.555397,140.128723 36.094891,140.327423 36.798691,140.769241 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M120.860191,3.652009 
	C120.687012,3.745757 120.380737,3.627392 119.945648,3.290149 
	C120.120247,3.194146 120.423676,3.317021 120.860191,3.652009 
z"
                />
                <path
                  fill="#4C6BC4"
                  opacity="1.000000"
                  stroke="none"
                  d="
M43.139435,144.576111 
	C42.914360,144.701935 42.587296,144.568069 42.137283,144.190979 
	C42.355373,144.070633 42.696411,144.193512 43.139435,144.576111 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M125.866837,6.618898 
	C125.637321,6.862405 125.352913,6.748985 125.031975,6.257661 
	C125.254921,6.058241 125.527084,6.185646 125.866837,6.618898 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M90.053543,62.173851 
	C90.072159,62.394737 89.808769,62.646225 89.270699,62.942688 
	C89.254524,62.726585 89.513023,62.465519 90.053543,62.173851 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M91.942116,61.116859 
	C91.964737,61.317093 91.738770,61.559258 91.261253,61.832504 
	C91.237640,61.628651 91.465584,61.393723 91.942116,61.116859 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M95.125519,59.198814 
	C95.145279,59.432014 94.865822,59.689976 94.302444,60.001579 
	C94.287773,59.778008 94.557037,59.500793 95.125519,59.198814 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M96.879730,58.144077 
	C96.922462,58.349659 96.719971,58.616920 96.260880,58.926155 
	C96.214348,58.714008 96.424423,58.459881 96.879730,58.144077 
z"
                />
                <path
                  fill="#E2FDFD"
                  opacity="1.000000"
                  stroke="none"
                  d="
M127.858154,7.682607 
	C127.680801,7.780486 127.368881,7.656750 126.917061,7.313079 
	C127.092636,7.215760 127.408104,7.338376 127.858154,7.682607 
z"
                />
                <path
                  fill="#F7FEFE"
                  opacity="1.000000"
                  stroke="none"
                  d="
M115.854004,88.883072 
	C115.972473,90.786461 116.005241,92.279991 116.005493,93.773514 
	C116.007675,106.657295 115.202034,107.919289 103.032578,112.914566 
	C101.850601,113.399734 100.055618,113.378128 98.925644,112.820625 
	C95.362556,111.062706 91.847313,109.128433 88.596519,106.857384 
	C87.357140,105.991547 86.840179,104.049767 86.093262,102.548935 
	C85.894608,102.149765 86.147614,101.550735 86.050751,101.072319 
	C84.086548,91.371201 87.856850,85.131859 97.077866,81.554382 
	C99.958763,80.436684 102.160339,79.708420 104.875320,81.574760 
	C108.411140,84.005379 112.119255,86.185371 115.854004,88.883072 
z"
                />
              </svg>
              <p style={{ fontWeight: "bold", fontSize: "2rem" }}>Digitinary</p>
              <div className="project-links">
                <a
                  href="https://digitinary.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Software Engineer</h3>
              <p>
                At Digitinary, I'm working as a software engineer, focusing on
                delivering scalable and efficient solutions for banking
                services. As part of my role, I am outsourced to Warba Bank,
                where I contribute to frontend and backend development.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>March 12, 2023</li> <li>⟶</li> <li>Present</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn" duration={3}>
          <div className="project">
            <header>
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="50"
                viewBox="0 0 327 307"
                enableBackground="new 0 0 327 307"
              >
                <path
                  fill="#C30F5C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M21.000000,308.000000 
	C14.374109,308.000000 7.748218,308.000000 1.000000,308.000000 
	C1.000000,290.979279 1.000000,273.958282 1.290659,256.290436 
	C6.787145,251.682007 7.423076,251.741409 11.384259,256.538391 
	C17.341333,254.153397 23.786732,252.257568 22.353514,243.490067 
	C22.240778,242.800400 24.665293,240.968033 25.971609,240.903610 
	C30.939297,240.658630 35.937550,240.803391 40.913544,241.035095 
	C44.413448,241.198059 46.359619,240.149612 46.024487,236.287262 
	C45.786758,233.547470 46.426743,231.215134 49.725792,230.861374 
	C57.880657,229.986923 66.051643,228.444229 74.193848,228.573593 
	C79.173386,228.652695 80.777794,227.486130 81.106873,222.829453 
	C81.427299,218.295135 84.747566,216.409653 89.170052,217.146118 
	C92.561882,217.710953 96.097206,217.985886 99.499794,217.663132 
	C101.101273,217.511230 103.787369,215.719818 103.851418,214.554291 
	C104.269135,206.952560 109.105438,206.477097 114.873917,206.913574 
	C117.184242,207.088409 119.536354,207.136261 121.828606,206.878571 
	C122.564362,206.795853 123.169136,205.548004 123.993507,204.588165 
	C124.463898,203.630005 124.774612,202.916855 125.293900,201.832703 
	C125.540321,199.147385 125.603310,196.833145 125.612114,194.518723 
	C125.685089,175.333679 125.748039,156.148605 126.121552,136.974426 
	C126.633636,137.000549 126.838211,137.015793 127.033676,137.497681 
	C127.023651,148.970718 127.022736,159.977112 127.016220,171.453186 
	C127.007950,179.858490 126.930595,187.795364 127.058487,195.728912 
	C127.088081,197.564697 127.819023,199.389175 128.227234,201.218857 
	C128.670975,201.123810 129.114716,201.028763 129.558456,200.933716 
	C129.872253,198.569534 130.186035,196.205368 130.487823,193.931702 
	C138.295456,192.889435 138.348328,192.837509 142.703415,182.604752 
	C143.532883,182.554581 144.005096,182.470093 144.550079,182.417038 
	C144.622864,182.448471 144.590225,182.603622 144.509186,182.966156 
	C145.778976,185.016327 147.129791,186.703964 148.529785,188.410034 
	C148.578934,188.428467 148.572693,188.533295 148.587204,188.806549 
	C149.000244,189.415726 149.398773,189.751663 149.940521,190.208221 
	C150.083740,190.328857 150.194565,190.686600 150.210403,191.047607 
	C151.589279,192.541473 152.952316,193.674332 154.508621,194.885239 
	C154.940445,195.128677 155.100372,195.350723 155.324280,195.904785 
	C156.007599,196.449265 156.548264,196.718353 157.403198,197.119781 
	C167.908936,204.249268 179.157623,206.792084 191.297287,204.709366 
	C207.870392,201.866028 218.826187,191.869186 225.947144,176.760666 
	C226.921616,176.021957 227.638672,175.432449 227.953873,175.173325 
	C230.909714,178.794769 233.685226,182.195297 236.472595,185.692566 
	C236.484451,185.789291 236.502487,185.595169 236.445282,185.950562 
	C237.328949,187.142715 238.269821,187.979462 239.131500,188.876526 
	C239.052307,188.936874 239.186783,188.790024 239.177917,189.163391 
	C239.994217,190.113541 240.819397,190.690353 241.517670,191.389343 
	C241.390762,191.511536 241.677490,191.306778 241.656464,191.668671 
	C243.061264,193.017334 244.487106,194.004135 245.964142,194.990341 
	C246.015335,194.989761 246.017197,195.092163 246.119385,195.420670 
	C248.049576,196.753265 249.877548,197.757339 251.775955,198.703339 
	C251.846375,198.645248 251.979141,198.770538 252.065369,199.111588 
	C252.837357,201.302643 253.523117,203.152664 254.208878,205.002670 
	C252.169189,205.158234 250.060516,205.722534 248.102844,205.392166 
	C242.397324,204.429291 234.411835,208.660324 233.421631,213.251495 
	C233.071838,214.873398 232.131485,217.458328 231.129623,217.626083 
	C228.928040,217.994736 226.515305,217.102341 225.505508,216.938446 
	C222.879089,216.938446 221.223053,217.418701 220.085953,216.854004 
	C215.550903,214.601807 212.305786,216.250183 211.608521,221.498184 
	C211.260818,224.115234 211.013031,226.745590 210.692673,229.615189 
	C204.568222,230.040329 198.302628,230.485382 192.034439,230.890091 
	C191.561661,230.920624 190.859283,230.826538 190.619614,230.515823 
	C187.539474,226.522629 184.110901,230.471527 180.843781,230.203476 
	C175.131363,229.734818 177.733429,235.550461 175.966705,238.209152 
	C175.292297,239.224060 175.115463,240.569595 174.582718,242.146851 
	C173.363968,240.867798 172.481384,239.941528 171.927994,239.360733 
	C169.076508,240.277557 166.492065,241.929733 164.130447,241.656448 
	C161.286255,241.327316 158.642944,241.603622 156.005325,242.139664 
	C152.935257,242.763611 151.168640,244.291748 153.210587,247.823700 
	C153.754761,248.764969 153.659943,250.834198 152.977264,251.599335 
	C149.368607,255.643982 143.528503,255.490631 140.256073,252.436768 
	C137.878235,252.754135 136.136902,252.555389 134.902512,253.253296 
	C133.091751,254.277100 129.437119,252.172348 129.472214,256.565155 
	C129.496078,259.552002 128.815704,262.544434 128.585281,264.429565 
	C121.638641,263.668549 115.478226,262.993652 108.656471,262.246338 
	C107.637672,264.015991 105.956589,265.998962 105.279091,268.280029 
	C102.757935,276.768433 100.049667,278.223999 92.116119,274.808685 
	C88.665802,273.323364 82.357742,274.779816 81.135254,278.176514 
	C77.449486,288.417419 69.203728,288.742676 60.742706,287.730682 
	C54.042782,286.929321 48.572777,289.026367 44.102364,291.479645 
	C44.102364,294.412384 44.102364,296.379181 44.102364,298.346008 
	C42.798168,297.963562 41.493977,297.581146 40.189789,297.198730 
	C37.037384,298.891876 33.352749,300.561646 29.714684,300.465698 
	C22.699764,300.280701 21.145227,301.190491 21.000000,308.000000 
M87.470955,271.499786 
	C87.470955,271.499786 87.512459,271.484100 87.470955,271.499786 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M21.468658,308.000000 
	C21.145227,301.190491 22.699764,300.280701 29.714684,300.465698 
	C33.352749,300.561646 37.037384,298.891876 40.189789,297.198730 
	C41.493977,297.581146 42.798168,297.963562 44.102364,298.346008 
	C44.102364,296.379181 44.102364,294.412384 44.102364,291.479645 
	C48.572777,289.026367 54.042782,286.929321 60.742706,287.730682 
	C69.203728,288.742676 77.449486,288.417419 81.135254,278.176514 
	C82.357742,274.779816 88.665802,273.323364 92.116119,274.808685 
	C100.049667,278.223999 102.757935,276.768433 105.279091,268.280029 
	C105.956589,265.998962 107.637672,264.015991 108.656471,262.246338 
	C115.478226,262.993652 121.638641,263.668549 128.585281,264.429565 
	C128.815704,262.544434 129.496078,259.552002 129.472214,256.565155 
	C129.437119,252.172348 133.091751,254.277100 134.902512,253.253296 
	C136.136902,252.555389 137.878235,252.754135 140.256073,252.436768 
	C143.528503,255.490631 149.368607,255.643982 152.977264,251.599335 
	C153.659943,250.834198 153.754761,248.764969 153.210587,247.823700 
	C151.168640,244.291748 152.935257,242.763611 156.005325,242.139664 
	C158.642944,241.603622 161.286255,241.327316 164.130447,241.656448 
	C166.492065,241.929733 169.076508,240.277557 171.927994,239.360733 
	C172.481384,239.941528 173.363968,240.867798 174.582718,242.146851 
	C175.115463,240.569595 175.292297,239.224060 175.966705,238.209152 
	C177.733429,235.550461 175.131363,229.734818 180.843781,230.203476 
	C184.110901,230.471527 187.539474,226.522629 190.619614,230.515823 
	C190.859283,230.826538 191.561661,230.920624 192.034439,230.890091 
	C198.302628,230.485382 204.568222,230.040329 210.692673,229.615189 
	C211.013031,226.745590 211.260818,224.115234 211.608521,221.498184 
	C212.305786,216.250183 215.550903,214.601807 220.085953,216.854004 
	C221.223053,217.418701 222.879089,216.938446 225.505508,216.938446 
	C226.515305,217.102341 228.928040,217.994736 231.129623,217.626083 
	C232.131485,217.458328 233.071838,214.873398 233.421631,213.251495 
	C234.411835,208.660324 242.397324,204.429291 248.102844,205.392166 
	C250.060516,205.722534 252.169189,205.158234 254.208878,205.002670 
	C253.523117,203.152664 252.837357,201.302643 252.443146,199.151855 
	C273.850769,208.753174 300.438141,204.165543 311.345428,188.441727 
	C308.928345,185.883286 306.449890,183.259827 304.101929,180.352600 
	C308.263916,178.291382 312.295410,176.513931 316.346222,174.727966 
	C320.848206,177.662064 323.975250,176.962540 326.226868,172.493301 
	C326.814362,171.327103 327.408752,170.164337 328.000000,169.000000 
	C328.000000,181.354233 328.000000,193.708450 327.785156,206.365952 
	C323.856659,206.314484 321.077545,207.093185 318.434174,210.451294 
	C314.590698,215.333984 309.480103,218.997543 302.673767,218.967041 
	C298.382751,218.947815 294.078308,219.200394 289.804077,218.937393 
	C285.632324,218.680664 283.915863,219.937988 283.863739,224.460693 
	C283.778442,231.864624 279.061768,234.589005 272.056854,232.104050 
	C270.686188,231.617844 268.948181,231.793488 267.459564,232.079773 
	C261.752319,233.177383 261.612274,237.472580 261.725647,242.091827 
	C256.735657,242.183640 252.020020,242.183640 247.124054,242.183640 
	C247.124054,244.084076 246.791489,245.809967 247.187393,247.348404 
	C248.305817,251.694565 245.750870,253.394974 242.325531,253.768570 
	C237.788940,254.263382 233.167923,254.305542 228.602127,254.107040 
	C225.088867,253.954285 222.689346,254.953766 223.305710,258.678070 
	C223.998947,262.866943 221.570114,263.944489 218.508057,264.845947 
	C216.446182,265.452942 213.448685,265.377136 212.476028,266.747192 
	C208.700302,272.065430 203.329620,271.062714 198.117676,271.635529 
	C195.062012,271.971375 192.140335,273.633789 189.190063,274.780884 
	C187.426910,275.466400 185.789139,276.638824 183.977997,276.991547 
	C182.057709,277.365570 179.998840,277.028015 177.653152,276.776733 
	C173.518356,276.367676 169.731705,276.045380 165.943344,276.024139 
	C153.992111,275.957123 153.991867,276.000793 154.000305,288.000000 
	C154.000000,288.000000 154.000610,288.001190 153.579666,288.000610 
	C147.351120,288.014069 141.538040,287.882996 135.738144,288.101593 
	C132.705566,288.215820 129.927811,288.556305 130.437057,293.300049 
	C130.656433,295.343536 128.153748,299.419525 126.547005,299.603943 
	C120.931595,300.248413 117.404228,302.525726 116.000000,308.000000 
	C84.645775,308.000000 53.291542,308.000000 21.468658,308.000000 
z"
                />
                <path
                  fill="#B4126F"
                  opacity="1.000000"
                  stroke="none"
                  d="
M178.000504,277.001221 
	C179.998840,277.028015 182.057709,277.365570 183.977997,276.991547 
	C185.789139,276.638824 187.426910,275.466400 189.190063,274.780884 
	C192.140335,273.633789 195.062012,271.971375 198.117676,271.635529 
	C203.329620,271.062714 208.700302,272.065430 212.476028,266.747192 
	C213.448685,265.377136 216.446182,265.452942 218.508057,264.845947 
	C221.570114,263.944489 223.998947,262.866943 223.305710,258.678070 
	C222.689346,254.953766 225.088867,253.954285 228.602127,254.107040 
	C233.167923,254.305542 237.788940,254.263382 242.325531,253.768570 
	C245.750870,253.394974 248.305817,251.694565 247.187393,247.348404 
	C246.791489,245.809967 247.124054,244.084076 247.124054,242.183640 
	C252.020020,242.183640 256.735657,242.183640 261.908264,242.222076 
	C266.430389,242.014282 270.501526,241.840485 274.559509,241.507126 
	C283.679138,240.757965 283.676483,240.725739 283.761017,231.637695 
	C289.903687,230.868637 296.152588,230.371506 302.269348,229.190262 
	C304.990570,228.664764 307.986298,227.302353 309.916382,225.376633 
	C315.011963,220.292587 320.549530,216.991409 328.000000,218.000000 
	C328.000000,237.354233 328.000000,256.708466 327.710114,276.398834 
	C326.063202,276.177765 324.706177,275.620575 322.974152,274.909363 
	C321.668854,276.872437 319.913025,278.611969 319.234314,280.701355 
	C317.133545,287.168640 313.301422,288.215790 309.509979,284.433929 
	C306.324188,285.146088 302.757324,286.850586 301.898651,285.955902 
	C299.786804,283.755554 298.548981,285.564026 298.019867,286.408936 
	C296.409271,288.980835 294.824432,291.750519 294.113037,294.659271 
	C293.165344,298.534363 290.225067,301.938416 287.121307,300.472809 
	C282.577454,298.327118 275.536682,301.866058 273.803650,293.890839 
	C269.638000,298.533447 270.614746,303.317627 271.000000,308.000000 
	C225.979111,308.000000 180.958206,308.000000 135.492188,307.635864 
	C136.171326,300.811096 141.114777,300.081543 146.265045,300.067108 
	C150.251007,300.055908 153.162933,298.368073 154.314072,294.793396 
	C154.964828,292.772552 154.153412,290.280823 154.000610,288.001190 
	C154.000610,288.001190 154.000000,288.000000 154.422348,288.009827 
	C159.745438,288.019348 164.651428,288.164062 169.545746,287.986603 
	C178.003021,287.679993 178.000031,287.596069 178.001831,278.985321 
	C178.001968,278.323944 178.000977,277.662598 178.000504,277.001221 
z"
                />
                <path
                  fill="#DD0A3C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M280.000000,0.999997 
	C295.888519,1.000000 311.777069,1.000000 328.000000,1.000000 
	C328.000000,6.014250 328.000000,11.035927 327.586426,16.530529 
	C324.514130,18.213083 319.558228,19.453465 319.573944,20.627279 
	C319.667664,27.627947 315.894623,28.553961 310.363647,28.125469 
	C308.940247,28.015198 307.456177,28.687555 305.588623,28.969894 
	C299.428528,28.637671 293.662323,27.976961 287.941803,28.254993 
	C286.246155,28.337406 283.271057,31.101526 283.311462,32.569962 
	C283.443787,37.377838 281.395111,39.464546 276.576172,40.009979 
	C272.687561,40.358891 269.144867,40.373360 265.791779,41.178005 
	C264.173553,41.566330 262.247375,43.165390 261.612213,44.694557 
	C259.604675,49.527874 257.764435,54.020081 251.151337,53.109497 
	C250.027802,52.954792 248.252533,53.567219 247.629883,54.435715 
	C245.098923,57.966019 241.561798,58.087502 237.813828,58.015549 
	C234.320053,57.948479 230.740189,57.565472 227.360367,58.193741 
	C225.388641,58.560257 223.712677,60.609009 221.946182,61.956657 
	C220.765076,62.857719 219.744339,64.518654 218.501831,64.679306 
	C215.587952,65.056061 212.546631,64.448006 209.633133,64.826141 
	C208.298187,64.999390 206.466873,66.308182 206.018295,67.527779 
	C203.525665,74.304794 202.316849,75.393784 195.102737,75.965797 
	C187.109909,76.599564 186.467194,77.258507 186.235901,85.627953 
	C184.041275,85.749771 181.785431,85.815964 179.540833,86.011444 
	C174.291534,86.468575 169.046814,87.393127 163.801712,87.382935 
	C156.655212,87.369049 153.841187,90.293884 153.180145,97.571297 
	C152.662506,103.269966 152.079376,103.690666 157.900330,104.084503 
	C160.622742,104.268707 163.282928,105.372505 165.517654,106.171494 
	C145.807220,106.299026 126.550400,106.351372 107.293739,106.316956 
	C94.852379,106.294724 82.411247,106.145432 69.920082,105.728531 
	C67.615753,101.623306 67.919685,98.703491 72.415878,96.812294 
	C73.200256,96.482368 73.485886,94.966705 74.000931,93.999344 
	C74.000000,94.000000 73.998741,94.001862 74.389420,93.975800 
	C76.247795,93.665977 78.144661,92.660606 79.104187,93.231285 
	C82.211166,95.079155 83.739182,92.387344 85.867653,91.467354 
	C90.703888,89.377007 95.745827,85.171761 100.289810,85.662529 
	C105.770210,86.254425 108.103821,83.520355 111.392082,81.057236 
	C112.437477,80.274170 113.590752,79.575508 114.792778,79.072845 
	C117.824570,77.805008 121.272919,77.194504 123.907036,75.380592 
	C130.701172,70.701981 137.424698,66.225288 145.667282,64.254738 
	C149.594452,63.315876 153.181961,60.956234 157.283081,59.075165 
	C161.945236,63.142082 163.978027,56.256287 167.733002,55.882454 
	C169.986801,56.465408 172.689087,57.270771 174.380569,56.305275 
	C178.467209,53.972626 182.079651,50.810101 185.888748,47.989559 
	C186.668579,47.412109 187.704941,46.222805 188.227448,46.411427 
	C191.652496,47.647831 192.544556,44.989311 193.802948,43.006962 
	C196.032440,39.494884 198.412811,37.006184 202.287766,41.078648 
	C203.754776,39.948368 205.042252,38.956409 206.371872,37.931984 
	C208.924911,40.863224 210.070526,39.372780 212.012650,37.093895 
	C215.928040,32.499565 219.055893,26.224573 227.041199,27.781403 
	C228.141083,27.995840 229.813080,26.732872 230.802704,25.738428 
	C232.606781,23.925594 233.955383,22.105156 237.090744,23.591253 
	C238.752029,24.378664 241.011932,23.903065 243.034378,24.058981 
	C243.067154,24.120321 243.218018,24.134199 243.218018,24.134199 
	C243.218018,24.134199 242.997559,24.001677 243.130753,23.680176 
	C248.850784,20.549965 254.436218,17.738449 260.024963,14.933576 
	C263.545532,13.166680 267.337616,11.788324 270.522308,9.545995 
	C273.975403,7.114708 276.864777,3.882772 280.000000,0.999997 
M131.527908,73.500099 
	C131.527908,73.500099 131.486359,73.516006 131.527908,73.500099 
M127.527840,75.500076 
	C127.527840,75.500076 127.486305,75.516006 127.527840,75.500076 
z"
                />
                <path
                  fill="#E01536"
                  opacity="1.000000"
                  stroke="none"
                  d="
M279.531342,0.999997 
	C276.864777,3.882772 273.975403,7.114708 270.522308,9.545995 
	C267.337616,11.788324 263.545532,13.166680 260.024963,14.933576 
	C254.436218,17.738449 248.850784,20.549965 243.131973,23.679337 
	C243.000000,24.000000 243.001602,23.997641 243.001602,23.997641 
	C241.011932,23.903065 238.752029,24.378664 237.090744,23.591253 
	C233.955383,22.105156 232.606781,23.925594 230.802704,25.738428 
	C229.813080,26.732872 228.141083,27.995840 227.041199,27.781403 
	C219.055893,26.224573 215.928040,32.499565 212.012650,37.093895 
	C210.070526,39.372780 208.924911,40.863224 206.371872,37.931984 
	C205.042252,38.956409 203.754776,39.948368 202.287766,41.078648 
	C198.412811,37.006184 196.032440,39.494884 193.802948,43.006962 
	C192.544556,44.989311 191.652496,47.647831 188.227448,46.411427 
	C187.704941,46.222805 186.668579,47.412109 185.888748,47.989559 
	C182.079651,50.810101 178.467209,53.972626 174.380569,56.305275 
	C172.689087,57.270771 169.986801,56.465408 167.733002,55.882454 
	C163.978027,56.256287 161.945236,63.142082 157.283081,59.075165 
	C153.181961,60.956234 149.594452,63.315876 145.667282,64.254738 
	C137.424698,66.225288 130.701172,70.701981 123.907036,75.380592 
	C121.272919,77.194504 117.824570,77.805008 114.792778,79.072845 
	C113.590752,79.575508 112.437477,80.274170 111.392082,81.057236 
	C108.103821,83.520355 105.770210,86.254425 100.289810,85.662529 
	C95.745827,85.171761 90.703888,89.377007 85.867653,91.467354 
	C83.739182,92.387344 82.211166,95.079155 79.104187,93.231285 
	C78.144661,92.660606 76.247795,93.665977 74.356552,93.914162 
	C73.933006,93.878586 73.780640,93.865028 73.780640,93.865028 
	C73.780640,93.865028 74.001869,93.998688 74.001862,93.998688 
	C73.485886,94.966705 73.200256,96.482368 72.415878,96.812294 
	C67.919685,98.703491 67.615753,101.623306 69.586342,105.844299 
	C67.947540,106.552292 66.592552,106.819977 64.872581,107.122345 
	C57.040916,108.035576 57.168858,108.039780 56.915096,115.765480 
	C56.846714,117.847282 55.743938,119.895103 55.094719,121.505905 
	C54.689026,116.365189 54.304596,111.677094 53.966187,106.991257 
	C54.012211,106.993507 54.008240,107.085571 53.819321,106.834831 
	C53.251457,106.409477 52.872513,106.234863 52.069302,106.172867 
	C42.801445,106.498039 33.957851,106.710602 24.875248,107.102852 
	C20.637035,110.729324 23.944866,115.153358 22.738874,119.160583 
	C16.100931,123.624771 7.683974,124.521599 2.851018,131.302032 
	C2.690730,131.526901 1.637172,131.115051 1.000001,131.000000 
	C1.000000,122.979103 1.000000,114.958199 1.352850,106.500610 
	C3.059006,106.596016 4.412311,107.128113 5.436405,107.530769 
	C7.923376,105.337585 9.880897,102.905693 12.410604,101.513504 
	C19.828102,97.431427 27.436447,93.687637 35.047871,89.970734 
	C37.962479,88.547440 41.343620,87.965752 44.057949,86.272446 
	C48.248383,83.658272 54.595448,86.001526 57.404938,80.324036 
	C57.571754,79.986938 59.017010,80.003738 59.722343,80.258057 
	C63.685730,81.687103 65.935616,79.875648 67.301559,75.960411 
	C67.804298,77.067902 68.118172,77.759331 68.605141,78.832062 
	C70.070030,75.292114 71.868645,72.664581 75.811012,75.499496 
	C78.047913,70.550529 81.357018,67.910217 87.021835,68.673943 
	C88.626213,68.890251 90.589172,67.987007 92.098000,67.102859 
	C98.321449,63.455978 102.986488,57.459995 111.786545,58.050232 
	C115.577698,58.304504 119.703690,53.566517 124.207397,50.767174 
	C125.855942,52.430855 127.666718,52.226006 129.472229,48.970940 
	C131.056870,46.114052 133.463547,44.052731 137.320633,46.259830 
	C138.101456,46.706627 139.970840,45.712898 141.103027,45.006222 
	C146.922379,41.373936 151.899033,36.118633 159.498184,36.014462 
	C160.675781,35.998318 161.809311,34.870380 163.018890,34.399605 
	C163.934525,34.043232 164.961578,33.982655 165.898453,33.669178 
	C167.411301,33.162991 168.979370,32.718914 170.366013,31.959806 
	C173.314728,30.345572 176.092850,28.411234 179.080063,26.879509 
	C180.537262,26.132307 182.394989,26.195560 183.913071,25.530516 
	C185.959564,24.633974 187.743896,22.783112 189.832962,22.405651 
	C196.387512,21.221340 200.899734,15.647676 207.652695,14.719112 
	C210.578354,14.316819 213.286652,10.467885 215.979614,10.595291 
	C223.501099,10.951140 227.238525,6.974330 230.000000,1.000000 
	C246.354233,1.000000 262.708466,1.000000 279.531342,0.999997 
M238.527100,21.502489 
	C238.527100,21.502489 238.485107,21.518505 238.527100,21.502489 
M244.471939,18.499851 
	C244.471939,18.499851 244.513748,18.483761 244.471939,18.499851 
M160.471970,55.499855 
	C160.471970,55.499855 160.513779,55.483761 160.471970,55.499855 
M119.498489,73.529663 
	C119.498489,73.529663 119.482773,73.487686 119.498489,73.529663 
z"
                />
                <path
                  fill="#E22231"
                  opacity="1.000000"
                  stroke="none"
                  d="
M229.531342,1.000000 
	C227.238525,6.974330 223.501099,10.951140 215.979614,10.595291 
	C213.286652,10.467885 210.578354,14.316819 207.652695,14.719112 
	C200.899734,15.647676 196.387512,21.221340 189.832962,22.405651 
	C187.743896,22.783112 185.959564,24.633974 183.913071,25.530516 
	C182.394989,26.195560 180.537262,26.132307 179.080063,26.879509 
	C176.092850,28.411234 173.314728,30.345572 170.366013,31.959806 
	C168.979370,32.718914 167.411301,33.162991 165.898453,33.669178 
	C164.961578,33.982655 163.934525,34.043232 163.018890,34.399605 
	C161.809311,34.870380 160.675781,35.998318 159.498184,36.014462 
	C151.899033,36.118633 146.922379,41.373936 141.103027,45.006222 
	C139.970840,45.712898 138.101456,46.706627 137.320633,46.259830 
	C133.463547,44.052731 131.056870,46.114052 129.472229,48.970940 
	C127.666718,52.226006 125.855942,52.430855 124.207397,50.767174 
	C119.703690,53.566517 115.577698,58.304504 111.786545,58.050232 
	C102.986488,57.459995 98.321449,63.455978 92.098000,67.102859 
	C90.589172,67.987007 88.626213,68.890251 87.021835,68.673943 
	C81.357018,67.910217 78.047913,70.550529 75.811012,75.499496 
	C71.868645,72.664581 70.070030,75.292114 68.605141,78.832062 
	C68.118172,77.759331 67.804298,77.067902 67.301559,75.960411 
	C65.935616,79.875648 63.685730,81.687103 59.722343,80.258057 
	C59.017010,80.003738 57.571754,79.986938 57.404938,80.324036 
	C54.595448,86.001526 48.248383,83.658272 44.057949,86.272446 
	C41.343620,87.965752 37.962479,88.547440 35.047871,89.970734 
	C27.436447,93.687637 19.828102,97.431427 12.410604,101.513504 
	C9.880897,102.905693 7.923376,105.337585 5.436405,107.530769 
	C4.412311,107.128113 3.059006,106.596016 1.352850,106.031960 
	C1.000000,99.312355 1.000000,92.624710 1.285949,85.275894 
	C5.445018,82.228798 9.179470,79.564323 13.235246,77.545334 
	C16.464579,75.937775 20.159922,75.292244 23.502804,73.876007 
	C25.191759,73.160477 26.481419,70.832512 28.082653,70.688278 
	C38.692951,69.732529 46.708569,63.689587 55.091900,58.030918 
	C58.652863,55.627300 63.189335,54.688084 67.241150,52.985043 
	C69.537308,52.019932 71.936523,51.121922 73.949814,49.709694 
	C76.164444,48.156227 77.451843,45.766655 81.140862,47.447014 
	C83.046356,48.314972 86.871750,47.414490 88.550056,45.897411 
	C94.734993,40.306625 102.871994,39.443882 109.949776,36.107418 
	C112.754967,34.785046 115.593735,33.533810 118.396843,32.207130 
	C120.126671,31.388416 121.893005,30.609222 123.513321,29.603455 
	C129.551102,25.855682 138.169388,27.427420 142.617294,20.254198 
	C143.137863,19.414688 145.024567,19.474258 146.231812,18.999670 
	C151.716553,16.843529 158.235626,17.245878 162.620300,12.305160 
	C163.210938,11.639614 164.337006,11.197480 165.256470,11.115527 
	C172.295273,10.488148 176.023865,4.784177 181.000000,1.000000 
	C197.020889,1.000000 213.041794,1.000000 229.531342,1.000000 
z"
                />
                <path
                  fill="#D70942"
                  opacity="1.000000"
                  stroke="none"
                  d="
M306.000000,29.000383 
	C307.456177,28.687555 308.940247,28.015198 310.363647,28.125469 
	C315.894623,28.553961 319.667664,27.627947 319.573944,20.627279 
	C319.558228,19.453465 324.514130,18.213083 327.586426,17.001726 
	C328.000000,25.020899 328.000000,33.041798 327.715027,41.634613 
	C323.249329,42.226383 320.763855,44.124283 319.718964,48.337429 
	C319.331238,49.900883 317.762634,52.235172 316.562164,52.344337 
	C312.007172,52.758549 309.179840,55.567993 305.908539,58.146206 
	C304.333832,59.387314 301.608734,59.153011 299.412720,59.624763 
	C294.281372,60.727085 288.094391,56.913227 283.989532,61.842216 
	C280.314514,66.255081 273.041443,66.187355 271.264374,72.701500 
	C271.091980,73.333389 269.647644,73.843132 268.723541,74.002304 
	C266.114410,74.451736 263.285065,74.202431 260.875671,75.111458 
	C255.876251,76.997673 248.154373,74.814514 247.429459,83.765900 
	C247.337967,84.895775 244.820190,86.449829 243.241119,86.718758 
	C239.002533,87.440620 234.589600,88.226738 230.385101,87.752678 
	C226.236191,87.284874 223.602905,88.776047 220.497833,91.057869 
	C216.310394,94.135063 211.784607,97.485130 206.901413,98.703308 
	C200.263931,100.359123 200.060196,99.542427 200.839691,106.152199 
	C200.701981,106.239433 200.413422,106.086617 200.138519,106.243256 
	C199.606781,106.729424 199.349960,107.058960 199.164337,107.527443 
	C199.235535,107.666397 199.064117,107.927406 198.795731,107.944290 
	C198.348419,107.972427 198.169495,107.983688 197.666336,108.107178 
	C196.168839,109.865448 194.995560,111.511475 194.509567,112.193291 
	C189.811920,111.751900 185.820938,111.137634 181.819382,111.058304 
	C176.146255,110.945824 175.122437,112.708107 175.481583,118.289719 
	C175.958725,125.704926 174.778366,132.888412 169.989975,138.564758 
	C169.988358,130.892639 170.170654,123.657227 169.902634,116.438530 
	C169.784790,113.264488 168.750168,110.124481 167.941742,106.725632 
	C167.158234,106.341339 166.564774,106.200424 165.971329,106.059509 
	C163.282928,105.372505 160.622742,104.268707 157.900330,104.084503 
	C152.079376,103.690666 152.662506,103.269966 153.180145,97.571297 
	C153.841187,90.293884 156.655212,87.369049 163.801712,87.382935 
	C169.046814,87.393127 174.291534,86.468575 179.540833,86.011444 
	C181.785431,85.815964 184.041275,85.749771 186.235901,85.627953 
	C186.467194,77.258507 187.109909,76.599564 195.102737,75.965797 
	C202.316849,75.393784 203.525665,74.304794 206.018295,67.527779 
	C206.466873,66.308182 208.298187,64.999390 209.633133,64.826141 
	C212.546631,64.448006 215.587952,65.056061 218.501831,64.679306 
	C219.744339,64.518654 220.765076,62.857719 221.946182,61.956657 
	C223.712677,60.609009 225.388641,58.560257 227.360367,58.193741 
	C230.740189,57.565472 234.320053,57.948479 237.813828,58.015549 
	C241.561798,58.087502 245.098923,57.966019 247.629883,54.435715 
	C248.252533,53.567219 250.027802,52.954792 251.151337,53.109497 
	C257.764435,54.020081 259.604675,49.527874 261.612213,44.694557 
	C262.247375,43.165390 264.173553,41.566330 265.791779,41.178005 
	C269.144867,40.373360 272.687561,40.358891 276.888580,40.224136 
	C278.423096,40.603634 279.264252,41.037113 280.012878,40.912918 
	C286.655670,39.810867 293.305389,38.725723 299.905243,37.397949 
	C304.343719,36.505009 306.963898,33.971825 306.000000,29.000383 
z"
                />
                <path
                  fill="#D10C4B"
                  opacity="1.000000"
                  stroke="none"
                  d="
M200.977417,106.064972 
	C200.060196,99.542427 200.263931,100.359123 206.901413,98.703308 
	C211.784607,97.485130 216.310394,94.135063 220.497833,91.057869 
	C223.602905,88.776047 226.236191,87.284874 230.385101,87.752678 
	C234.589600,88.226738 239.002533,87.440620 243.241119,86.718758 
	C244.820190,86.449829 247.337967,84.895775 247.429459,83.765900 
	C248.154373,74.814514 255.876251,76.997673 260.875671,75.111458 
	C263.285065,74.202431 266.114410,74.451736 268.723541,74.002304 
	C269.647644,73.843132 271.091980,73.333389 271.264374,72.701500 
	C273.041443,66.187355 280.314514,66.255081 283.989532,61.842216 
	C288.094391,56.913227 294.281372,60.727085 299.412720,59.624763 
	C301.608734,59.153011 304.333832,59.387314 305.908539,58.146206 
	C309.179840,55.567993 312.007172,52.758549 316.562164,52.344337 
	C317.762634,52.235172 319.331238,49.900883 319.718964,48.337429 
	C320.763855,44.124283 323.249329,42.226383 327.715027,42.103264 
	C328.000000,56.354229 328.000000,70.708458 327.657959,85.431992 
	C319.394257,86.253662 311.469177,86.654739 303.552429,87.180305 
	C299.664032,87.438446 296.522308,88.684120 295.960693,93.325371 
	C295.821655,94.474220 294.727020,96.334091 293.895538,96.436432 
	C289.014404,97.037231 287.983398,100.341881 288.077271,103.640793 
	C281.415375,104.084442 275.196564,104.498589 268.851257,105.043182 
	C268.724792,105.173630 268.368500,105.102135 267.983765,105.074059 
	C266.397003,105.332741 265.194977,105.619499 263.667816,106.092010 
	C247.014145,110.761429 236.018723,121.397575 228.741623,136.566345 
	C228.270401,128.221848 228.015015,120.132050 228.367645,112.068832 
	C228.574158,107.346603 226.895050,106.078072 222.368637,106.258614 
	C215.252121,106.542458 208.109177,106.163361 200.977417,106.064972 
z"
                />
                <path
                  fill="#E42E2C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M180.531342,1.000000 
	C176.023865,4.784177 172.295273,10.488148 165.256470,11.115527 
	C164.337006,11.197480 163.210938,11.639614 162.620300,12.305160 
	C158.235626,17.245878 151.716553,16.843529 146.231812,18.999670 
	C145.024567,19.474258 143.137863,19.414688 142.617294,20.254198 
	C138.169388,27.427420 129.551102,25.855682 123.513321,29.603455 
	C121.893005,30.609222 120.126671,31.388416 118.396843,32.207130 
	C115.593735,33.533810 112.754967,34.785046 109.949776,36.107418 
	C102.871994,39.443882 94.734993,40.306625 88.550056,45.897411 
	C86.871750,47.414490 83.046356,48.314972 81.140862,47.447014 
	C77.451843,45.766655 76.164444,48.156227 73.949814,49.709694 
	C71.936523,51.121922 69.537308,52.019932 67.241150,52.985043 
	C63.189335,54.688084 58.652863,55.627300 55.091900,58.030918 
	C46.708569,63.689587 38.692951,69.732529 28.082653,70.688278 
	C26.481419,70.832512 25.191759,73.160477 23.502804,73.876007 
	C20.159922,75.292244 16.464579,75.937775 13.235246,77.545334 
	C9.179470,79.564323 5.445018,82.228798 1.285949,84.807358 
	C1.000000,76.312439 1.000000,67.624870 1.279371,58.710777 
	C4.868095,60.990150 8.483602,60.763733 10.993391,57.927822 
	C14.642694,53.804333 19.396366,52.620022 24.187975,52.470669 
	C29.086666,52.317974 32.353901,50.544964 35.787567,47.201366 
	C38.939453,44.132156 43.127220,41.843334 47.241375,40.129650 
	C50.960453,38.580528 55.584816,39.046917 59.129944,37.268749 
	C68.371750,32.633259 77.180023,27.140614 86.311295,22.271290 
	C88.055313,21.341282 90.486656,21.700209 93.579483,21.355354 
	C93.577942,21.359276 94.104111,20.021603 94.618660,18.713446 
	C96.354218,19.187124 98.021606,20.237843 99.317657,19.892992 
	C104.981087,18.386074 110.661995,16.801197 115.543243,13.285127 
	C118.521187,11.140053 121.350540,8.095491 124.683014,7.312697 
	C128.774307,6.351655 131.105148,4.260376 133.000000,1.000000 
	C148.687561,1.000000 164.375122,1.000000 180.531342,1.000000 
z"
                />
                <path
                  fill="#C91155"
                  opacity="1.000000"
                  stroke="none"
                  d="
M23.066772,119.017563 
	C23.944866,115.153358 20.637035,110.729324 24.876650,107.580116 
	C25.117065,139.266220 25.117065,170.654755 25.117065,201.858795 
	C47.075954,201.858795 68.454124,201.858795 89.922119,201.858795 
	C89.922119,192.303802 89.922119,183.164017 90.286781,174.170074 
	C91.102417,176.330536 91.886375,178.335922 91.942253,180.361404 
	C92.113213,186.558533 92.004379,192.763367 92.004379,198.965210 
	C92.769196,198.971176 93.534004,198.977127 94.298820,198.983093 
	C95.927452,185.385162 94.229301,171.627243 95.189941,157.973969 
	C95.400940,157.960876 95.823547,157.947861 95.962402,158.144638 
	C96.272293,158.617493 96.493736,158.844360 96.824463,159.485931 
	C96.907860,173.973511 96.932381,187.997177 97.032700,202.335358 
	C99.427834,203.231766 101.726524,204.196014 104.070442,204.322556 
	C110.648262,204.677643 117.244728,204.687286 123.833839,204.833206 
	C123.169136,205.548004 122.564362,206.795853 121.828606,206.878571 
	C119.536354,207.136261 117.184242,207.088409 114.873917,206.913574 
	C109.105438,206.477097 104.269135,206.952560 103.851418,214.554291 
	C103.787369,215.719818 101.101273,217.511230 99.499794,217.663132 
	C96.097206,217.985886 92.561882,217.710953 89.170052,217.146118 
	C84.747566,216.409653 81.427299,218.295135 81.106873,222.829453 
	C80.777794,227.486130 79.173386,228.652695 74.193848,228.573593 
	C66.051643,228.444229 57.880657,229.986923 49.725792,230.861374 
	C46.426743,231.215134 45.786758,233.547470 46.024487,236.287262 
	C46.359619,240.149612 44.413448,241.198059 40.913544,241.035095 
	C35.937550,240.803391 30.939297,240.658630 25.971609,240.903610 
	C24.665293,240.968033 22.240778,242.800400 22.353514,243.490067 
	C23.786732,252.257568 17.341333,254.153397 11.384259,256.538391 
	C7.423076,251.741409 6.787145,251.682007 1.290659,255.821777 
	C1.000000,243.979111 1.000000,231.958206 1.260921,219.567703 
	C5.078122,219.911896 7.793771,219.024460 10.154775,215.944687 
	C11.574107,214.093292 13.953762,212.627350 16.200100,211.849121 
	C19.035599,210.866806 21.434429,210.047440 21.840395,206.581696 
	C22.413256,201.691177 23.153976,196.820343 23.846046,191.477020 
	C23.847593,184.658844 23.826025,178.304764 23.830608,171.485931 
	C23.881647,161.265518 24.023249,151.508301 23.893902,141.754684 
	C23.793362,134.173325 23.354992,126.596436 23.066772,119.017563 
z"
                />
                <path
                  fill="#C4105C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M328.000000,168.531342 
	C327.408752,170.164337 326.814362,171.327103 326.226868,172.493301 
	C323.975250,176.962540 320.848206,177.662064 316.346222,174.727966 
	C312.295410,176.513931 308.263916,178.291382 303.800415,180.323624 
	C302.265350,179.386719 301.162354,178.195007 300.105042,176.835449 
	C299.785004,176.443832 299.419250,176.220108 299.020844,175.999451 
	C298.988220,176.002533 298.990448,175.937012 298.864838,175.755035 
	C298.547913,175.344223 298.322449,175.156357 298.030090,175.010590 
	C297.997314,175.011749 298.003479,174.946472 297.984802,174.762970 
	C297.634460,174.391800 297.302765,174.204132 296.640991,173.908661 
	C294.619690,172.310699 292.928467,170.820541 291.186188,169.285431 
	C289.867798,170.290329 288.978455,171.014069 288.043823,171.673660 
	C275.607269,180.450241 257.682312,173.138046 255.063126,158.225876 
	C253.555847,149.644287 257.335297,141.451431 265.039307,136.600037 
	C272.005035,132.213547 280.925201,132.679230 287.999390,137.459320 
	C289.324646,138.354797 292.277435,139.023422 292.982391,138.312515 
	C299.017700,132.226227 304.708160,125.797951 310.725708,119.227379 
	C309.364441,117.969460 307.203339,115.972443 305.390137,113.954933 
	C310.361389,110.003448 313.981720,114.049622 317.923889,116.125641 
	C320.031372,111.330818 323.249084,109.253929 328.000000,110.000000 
	C328.000000,129.354233 328.000000,148.708450 328.000000,168.531342 
M302.498596,174.529297 
	C302.498596,174.529297 302.483063,174.487701 302.498596,174.529297 
z"
                />
                <path
                  fill="#E63B28"
                  opacity="1.000000"
                  stroke="none"
                  d="
M132.531342,1.000000 
	C131.105148,4.260376 128.774307,6.351655 124.683014,7.312697 
	C121.350540,8.095491 118.521187,11.140053 115.543243,13.285127 
	C110.661995,16.801197 104.981087,18.386074 99.317657,19.892992 
	C98.021606,20.237843 96.354218,19.187124 94.618660,18.713446 
	C94.104111,20.021603 93.577942,21.359276 93.579483,21.355354 
	C90.486656,21.700209 88.055313,21.341282 86.311295,22.271290 
	C77.180023,27.140614 68.371750,32.633259 59.129944,37.268749 
	C55.584816,39.046917 50.960453,38.580528 47.241375,40.129650 
	C43.127220,41.843334 38.939453,44.132156 35.787567,47.201366 
	C32.353901,50.544964 29.086666,52.317974 24.187975,52.470669 
	C19.396366,52.620022 14.642694,53.804333 10.993391,57.927822 
	C8.483602,60.763733 4.868095,60.990150 1.279371,58.242123 
	C1.000000,51.978848 1.000000,45.957695 1.182415,39.255890 
	C1.721351,37.865948 2.077873,37.156658 2.313207,36.688469 
	C3.574056,37.821247 4.837313,38.956188 5.807899,39.828186 
	C7.856578,38.644352 9.379953,37.300835 11.135994,36.835693 
	C16.529060,35.407169 20.029768,32.104458 22.241213,27.159021 
	C24.014967,28.293650 25.998554,30.448023 27.010027,30.061106 
	C33.351009,27.635504 41.816223,28.971292 44.713577,20.528725 
	C50.152309,21.351036 53.530083,19.137487 55.372025,14.002344 
	C57.828453,12.999856 59.914532,12.000443 62.266109,10.939884 
	C64.386093,11.193649 66.566978,12.291914 68.035324,11.680097 
	C72.906105,9.650581 77.700165,7.452693 82.633591,5.536392 
	C84.408607,4.846919 85.562592,2.558637 87.000000,1.000000 
	C102.020897,1.000000 117.041786,1.000000 132.531342,1.000000 
M57.467266,15.497705 
	C57.467266,15.497705 57.511398,15.480858 57.467266,15.497705 
z"
                />
                <path
                  fill="#E94A21"
                  opacity="1.000000"
                  stroke="none"
                  d="
M22.001627,27.003906 
	C20.029768,32.104458 16.529060,35.407169 11.135994,36.835693 
	C9.379953,37.300835 7.856578,38.644352 5.807899,39.828186 
	C4.837313,38.956188 3.574056,37.821247 2.313207,36.688469 
	C2.077873,37.156658 1.721351,37.865948 1.182415,38.787617 
	C1.000000,26.391336 1.000000,13.782674 1.000000,1.000000 
	C20.020540,1.000000 39.041611,1.000000 58.517479,1.339000 
	C59.981724,4.785677 60.991165,7.893353 62.000610,11.001028 
	C59.914532,12.000443 57.828453,12.999856 55.169426,13.717493 
	C52.502159,13.448550 50.300880,13.055220 48.339207,13.571786 
	C45.569317,14.301178 43.068035,16.099318 40.290318,16.740749 
	C33.142185,18.391403 26.584454,20.877958 22.001627,27.003906 
z"
                />
                <path
                  fill="#AD1478"
                  opacity="1.000000"
                  stroke="none"
                  d="
M271.468658,308.000000 
	C270.614746,303.317627 269.638000,298.533447 273.803650,293.890839 
	C275.536682,301.866058 282.577454,298.327118 287.121307,300.472809 
	C290.225067,301.938416 293.165344,298.534363 294.113037,294.659271 
	C294.824432,291.750519 296.409271,288.980835 298.019867,286.408936 
	C298.548981,285.564026 299.786804,283.755554 301.898651,285.955902 
	C302.757324,286.850586 306.324188,285.146088 309.509979,284.433929 
	C313.301422,288.215790 317.133545,287.168640 319.234314,280.701355 
	C319.913025,278.611969 321.668854,276.872437 322.974152,274.909363 
	C324.706177,275.620575 326.063202,276.177765 327.710114,276.867493 
	C328.000000,287.281677 328.000000,297.563385 328.000000,308.000000 
	C309.312683,308.000000 290.625000,308.000000 271.468658,308.000000 
z"
                />
                <path
                  fill="#CC0E53"
                  opacity="1.000000"
                  stroke="none"
                  d="
M328.000000,109.531364 
	C323.249084,109.253929 320.031372,111.330818 317.923889,116.125641 
	C313.981720,114.049622 310.361389,110.003448 305.060394,113.853386 
	C293.718781,106.272667 281.731476,104.061317 268.977753,104.912735 
	C275.196564,104.498589 281.415375,104.084442 288.077271,103.640793 
	C287.983398,100.341881 289.014404,97.037231 293.895538,96.436432 
	C294.727020,96.334091 295.821655,94.474220 295.960693,93.325371 
	C296.522308,88.684120 299.664032,87.438446 303.552429,87.180305 
	C311.469177,86.654739 319.394257,86.253662 327.657959,85.900650 
	C328.000000,93.687576 328.000000,101.375153 328.000000,109.531364 
z"
                />
                <path
                  fill="#DD0A3C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M22.738873,119.160583 
	C23.354992,126.596436 23.793362,134.173325 23.893902,141.754684 
	C24.023249,151.508301 23.881647,161.265518 23.481556,171.384933 
	C22.402479,168.390869 21.305790,165.056244 21.105906,161.668686 
	C20.908537,158.323822 19.842710,156.857437 16.392250,156.964371 
	C11.266055,157.123245 6.131180,157.002014 1.000000,157.000000 
	C1.000000,148.645767 1.000000,140.291534 1.000001,131.468643 
	C1.637172,131.115051 2.690730,131.526901 2.851018,131.302032 
	C7.683974,124.521599 16.100931,123.624771 22.738873,119.160583 
z"
                />
                <path
                  fill="#D70942"
                  opacity="1.000000"
                  stroke="none"
                  d="
M1.000000,157.468658 
	C6.131180,157.002014 11.266055,157.123245 16.392250,156.964371 
	C19.842710,156.857437 20.908537,158.323822 21.105906,161.668686 
	C21.305790,165.056244 22.402479,168.390869 23.455408,171.849670 
	C23.826025,178.304764 23.847593,184.658844 23.497692,191.444962 
	C21.834896,189.546417 20.935535,186.821426 19.120577,185.017761 
	C17.813839,183.719162 15.218003,183.021774 13.325555,183.228943 
	C11.815422,183.394287 9.243711,185.397995 9.302207,186.467590 
	C9.657697,192.967834 5.807294,193.444077 1.000000,193.000000 
	C1.000000,181.312439 1.000000,169.624878 1.000000,157.468658 
z"
                />
                <path
                  fill="#B8116A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M328.000000,217.541931 
	C320.549530,216.991409 315.011963,220.292587 309.916382,225.376633 
	C307.986298,227.302353 304.990570,228.664764 302.269348,229.190262 
	C296.152588,230.371506 289.903687,230.868637 283.761017,231.637695 
	C283.676483,240.725739 283.679138,240.757965 274.559509,241.507126 
	C270.501526,241.840485 266.430389,242.014282 262.182617,242.130249 
	C261.612274,237.472580 261.752319,233.177383 267.459564,232.079773 
	C268.948181,231.793488 270.686188,231.617844 272.056854,232.104050 
	C279.061768,234.589005 283.778442,231.864624 283.863739,224.460693 
	C283.915863,219.937988 285.632324,218.680664 289.804077,218.937393 
	C294.078308,219.200394 298.382751,218.947815 302.673767,218.967041 
	C309.480103,218.997543 314.590698,215.333984 318.434174,210.451294 
	C321.077545,207.093185 323.856659,206.314484 327.785156,206.834610 
	C328.000000,210.361282 328.000000,213.722580 328.000000,217.541931 
z"
                />
                <path
                  fill="#D20B4A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M1.000000,193.468658 
	C5.807294,193.444077 9.657697,192.967834 9.302207,186.467590 
	C9.243711,185.397995 11.815422,183.394287 13.325555,183.228943 
	C15.218003,183.021774 17.813839,183.719162 19.120577,185.017761 
	C20.935535,186.821426 21.834896,189.546417 23.474577,191.909027 
	C23.153976,196.820343 22.413256,201.691177 21.840395,206.581696 
	C21.434429,210.047440 19.035599,210.866806 16.200100,211.849121 
	C13.953762,212.627350 11.574107,214.093292 10.154775,215.944687 
	C7.793771,219.024460 5.078122,219.911896 1.260921,219.099045 
	C1.000000,210.645767 1.000000,202.291534 1.000000,193.468658 
z"
                />
                <path
                  fill="#B8116B"
                  opacity="1.000000"
                  stroke="none"
                  d="
M153.579666,288.000610 
	C154.153412,290.280823 154.964828,292.772552 154.314072,294.793396 
	C153.162933,298.368073 150.251007,300.055908 146.265045,300.067108 
	C141.114777,300.081543 136.171326,300.811096 135.023529,307.635864 
	C128.978851,308.000000 122.957695,308.000000 116.468269,308.000000 
	C117.404228,302.525726 120.931595,300.248413 126.547005,299.603943 
	C128.153748,299.419525 130.656433,295.343536 130.437057,293.300049 
	C129.927811,288.556305 132.705566,288.215820 135.738144,288.101593 
	C141.538040,287.882996 147.351120,288.014069 153.579666,288.000610 
z"
                />
                <path
                  fill="#E84623"
                  opacity="1.000000"
                  stroke="none"
                  d="
M62.266109,10.939884 
	C60.991165,7.893353 59.981724,4.785677 58.986137,1.339000 
	C68.020897,1.000000 77.041786,1.000000 86.531342,1.000000 
	C85.562592,2.558637 84.408607,4.846919 82.633591,5.536392 
	C77.700165,7.452693 72.906105,9.650581 68.035324,11.680097 
	C66.566978,12.291914 64.386093,11.193649 62.266109,10.939884 
M68.527557,8.502693 
	C68.527557,8.502693 68.486389,8.518734 68.527557,8.502693 
z"
                />
                <path
                  fill="#FDF8FC"
                  opacity="1.000000"
                  stroke="none"
                  d="
M268.851257,105.043182 
	C281.731476,104.061317 293.718781,106.272667 304.712524,113.873886 
	C307.203339,115.972443 309.364441,117.969460 310.725708,119.227379 
	C304.708160,125.797951 299.017700,132.226227 292.982391,138.312515 
	C292.277435,139.023422 289.324646,138.354797 287.999390,137.459320 
	C280.925201,132.679230 272.005035,132.213547 265.039307,136.600037 
	C257.335297,141.451431 253.555847,149.644287 255.063126,158.225876 
	C257.682312,173.138046 275.607269,180.450241 288.043823,171.673660 
	C288.978455,171.014069 289.867798,170.290329 291.186188,169.285431 
	C292.928467,170.820541 294.619690,172.310699 296.737244,174.138062 
	C297.364441,174.773315 297.644440,174.930389 298.003479,174.946472 
	C298.003479,174.946472 297.997314,175.011749 298.091492,175.242691 
	C298.370789,175.772461 298.639038,175.926926 298.990448,175.937012 
	C298.990448,175.937012 298.988220,176.002533 299.094604,176.245789 
	C299.487122,176.660477 299.773224,176.831894 300.059326,177.003311 
	C301.162354,178.195007 302.265350,179.386719 303.669891,180.607391 
	C306.449890,183.259827 308.928345,185.883286 311.345428,188.441727 
	C300.438141,204.165543 273.850769,208.753174 252.356903,198.810791 
	C251.979141,198.770538 251.846375,198.645248 251.596191,198.397827 
	C249.569748,197.130981 247.793472,196.111572 246.017197,195.092163 
	C246.017197,195.092163 246.015335,194.989761 245.856094,194.688324 
	C244.357056,193.360184 243.017273,192.333481 241.677490,191.306778 
	C241.677490,191.306778 241.390762,191.511536 241.412384,191.106659 
	C240.684921,190.064529 239.935852,189.427277 239.186783,188.790024 
	C239.186783,188.790024 239.052307,188.936874 239.017303,188.585617 
	C238.155685,187.354630 237.329086,186.474899 236.502487,185.595169 
	C236.502487,185.595169 236.484451,185.789291 236.362900,185.367508 
	C233.473282,180.038239 230.705231,175.130737 227.638245,169.693268 
	C226.875809,172.517059 226.282776,174.713470 225.689758,176.909866 
	C218.826187,191.869186 207.870392,201.866028 191.297287,204.709366 
	C179.157623,206.792084 167.908936,204.249268 157.276245,196.834442 
	C156.283936,196.154297 155.732788,195.891846 155.181656,195.629395 
	C155.100372,195.350723 154.940445,195.128677 154.401443,194.572418 
	C152.798859,193.016571 151.496704,191.851593 150.194565,190.686600 
	C150.194565,190.686600 150.083740,190.328857 149.941742,189.937317 
	C149.390717,189.208282 148.981705,188.870789 148.572693,188.533295 
	C148.572693,188.533295 148.578934,188.428467 148.433487,188.102432 
	C147.055435,186.052139 145.822830,184.327881 144.590225,182.603622 
	C144.590225,182.603622 144.622864,182.448471 144.463806,182.100204 
	C143.577423,180.399338 142.850098,179.046738 142.118805,177.413177 
	C141.985901,176.783920 141.856964,176.435608 141.769501,175.807892 
	C141.582275,175.252625 141.353607,174.976761 141.121078,174.421387 
	C140.988831,173.795319 140.860428,173.448792 140.781464,172.842377 
	C140.628967,172.315079 140.427002,172.047668 140.193344,171.817841 
	C140.161667,171.855438 140.259201,171.843048 140.282715,171.585495 
	C140.196075,171.195343 140.085907,171.062729 139.973419,170.620941 
	C139.879440,169.911499 139.787766,169.511215 139.780579,168.677261 
	C139.521866,157.258987 139.178665,146.274399 138.825058,134.956848 
	C135.244675,134.956848 132.111389,134.783646 129.015686,135.048889 
	C127.901955,135.144318 126.878616,136.294632 125.814034,136.963531 
	C125.748039,156.148605 125.685089,175.333679 125.612114,194.518723 
	C125.603310,196.833145 125.540321,199.147385 124.817612,201.836349 
	C115.074142,202.147614 106.015526,202.084229 96.956909,202.020828 
	C96.932381,187.997177 96.907860,173.973511 96.930145,159.026489 
	C96.976952,150.536240 96.976952,142.969345 96.976952,134.858826 
	C86.179329,134.858826 76.099289,134.858826 65.857178,134.488464 
	C65.482307,125.729172 65.269501,117.340263 65.163498,108.652275 
	C65.259392,107.931358 65.248482,107.509514 65.237564,107.087669 
	C66.592552,106.819977 67.947540,106.552292 69.636269,106.168839 
	C82.411247,106.145432 94.852379,106.294724 107.293739,106.316956 
	C126.550400,106.351372 145.807220,106.299026 165.517654,106.171494 
	C166.564774,106.200424 167.158234,106.341339 167.869980,107.193497 
	C167.975662,125.402763 167.866562,142.901474 167.990036,160.398529 
	C168.054352,169.510483 174.467957,176.283722 182.948349,176.711960 
	C191.251404,177.131226 198.982910,170.879898 199.141754,162.376953 
	C199.480667,144.233917 199.131409,126.078026 199.064117,107.927406 
	C199.064117,107.927406 199.235535,107.666397 199.432922,107.363693 
	C199.891357,106.736206 200.152390,106.411415 200.413422,106.086624 
	C200.413422,106.086617 200.701981,106.239433 200.839691,106.152206 
	C208.109177,106.163361 215.252121,106.542458 222.368637,106.258614 
	C226.895050,106.078072 228.574158,107.346603 228.367645,112.068832 
	C228.015015,120.132050 228.270401,128.221848 228.741623,136.566345 
	C236.018723,121.397575 247.014145,110.761429 264.045990,106.117218 
	C265.955719,105.671822 267.162109,105.386978 268.368500,105.102135 
	C268.368500,105.102135 268.724792,105.173630 268.851257,105.043182 
z"
                />
                <path
                  fill="#CC0C51"
                  opacity="1.000000"
                  stroke="none"
                  d="
M141.728027,176.087311 
	C141.856964,176.435608 141.985901,176.783920 142.068268,177.829620 
	C142.129837,179.874817 142.238007,181.222610 142.346161,182.570419 
	C138.348328,192.837509 138.295456,192.889435 130.487823,193.931702 
	C130.186035,196.205368 129.872253,198.569534 129.558456,200.933716 
	C129.114716,201.028763 128.670975,201.123810 128.227234,201.218857 
	C127.819023,199.389175 127.088081,197.564697 127.058487,195.728912 
	C126.930595,187.795364 127.007950,179.858490 127.382690,171.434540 
	C130.824921,169.296890 133.895096,167.647522 137.230469,166.002197 
	C137.672195,166.008606 137.848709,166.010956 138.089905,166.307587 
	C138.668411,167.438232 139.182251,168.274582 139.696091,169.110947 
	C139.787766,169.511215 139.879440,169.911499 139.860016,170.743896 
	C139.691559,171.573685 139.861649,171.796021 140.259201,171.843048 
	C140.259201,171.843048 140.161667,171.855438 140.163269,172.071320 
	C140.353912,172.558884 140.542953,172.830582 140.732010,173.102264 
	C140.860428,173.448792 140.988831,173.795319 141.110962,174.691498 
	C141.312454,175.523193 141.520248,175.805252 141.728027,176.087311 
z"
                />
                <path
                  fill="#D30B49"
                  opacity="1.000000"
                  stroke="none"
                  d="
M136.965286,165.998169 
	C133.895096,167.647522 130.824921,169.296890 127.388283,170.964890 
	C127.022736,159.977112 127.023651,148.970718 127.344650,137.431824 
	C130.885406,136.899353 134.106094,136.899353 136.725281,136.899353 
	C137.146744,146.202576 137.527771,154.613510 137.719025,163.278534 
	C137.341263,164.354462 137.153275,165.176315 136.965286,165.998169 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M137.908813,163.024445 
	C137.527771,154.613510 137.146744,146.202576 136.725281,136.899353 
	C134.106094,136.899353 130.885406,136.899353 127.353752,136.965210 
	C126.838211,137.015793 126.633636,137.000549 126.121552,136.974426 
	C126.878616,136.294632 127.901955,135.144318 129.015686,135.048889 
	C132.111389,134.783646 135.244675,134.956848 138.825058,134.956848 
	C139.178665,146.274399 139.521866,157.258987 139.780579,168.677261 
	C139.182251,168.274582 138.668411,167.438232 138.096481,165.932739 
	C137.995209,164.517227 137.952011,163.770844 137.908813,163.024445 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M97.032707,202.335358 
	C106.015526,202.084229 115.074142,202.147614 124.609047,202.207352 
	C124.774612,202.916855 124.463898,203.630005 123.993507,204.588165 
	C117.244728,204.687286 110.648262,204.677643 104.070442,204.322556 
	C101.726524,204.196014 99.427834,203.231766 97.032707,202.335358 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M225.947144,176.760666 
	C226.282776,174.713470 226.875809,172.517059 227.638245,169.693268 
	C230.705231,175.130737 233.473282,180.038239 236.351044,185.270782 
	C233.685226,182.195297 230.909714,178.794769 227.953873,175.173325 
	C227.638672,175.432449 226.921616,176.021957 225.947144,176.760666 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M144.509186,182.966156 
	C145.822830,184.327881 147.055435,186.052139 148.384338,188.083984 
	C147.129791,186.703964 145.778976,185.016327 144.509186,182.966156 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M150.210403,191.047607 
	C151.496704,191.851593 152.798859,193.016571 154.208176,194.494385 
	C152.952316,193.674332 151.589279,192.541473 150.210403,191.047607 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M241.656464,191.668671 
	C243.017273,192.333481 244.357056,193.360184 245.804901,194.688904 
	C244.487106,194.004135 243.061264,193.017334 241.656464,191.668671 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M142.703415,182.604752 
	C142.238007,181.222610 142.129837,179.874817 142.072235,178.110565 
	C142.850098,179.046738 143.577423,180.399338 144.391022,182.068771 
	C144.005096,182.470093 143.532883,182.554581 142.703415,182.604752 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M246.119385,195.420670 
	C247.793472,196.111572 249.569748,197.130981 251.525787,198.455902 
	C249.877548,197.757339 248.049576,196.753265 246.119385,195.420670 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M236.445282,185.950562 
	C237.329086,186.474899 238.155685,187.354630 239.096497,188.525269 
	C238.269821,187.979462 237.328949,187.142715 236.445282,185.950562 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M239.177917,189.163391 
	C239.935852,189.427277 240.684921,190.064529 241.539276,190.984467 
	C240.819397,190.690353 239.994217,190.113541 239.177917,189.163391 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M148.587204,188.806549 
	C148.981705,188.870789 149.390717,189.208282 149.798523,189.816681 
	C149.398773,189.751663 149.000244,189.415726 148.587204,188.806549 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M155.324280,195.904785 
	C155.732788,195.891846 156.283936,196.154297 156.962006,196.702103 
	C156.548264,196.718353 156.007599,196.449265 155.324280,195.904785 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M87.491707,271.491943 
	C87.512459,271.484100 87.470955,271.499786 87.491707,271.491943 
z"
                />
                <path
                  fill="#B8116B"
                  opacity="1.000000"
                  stroke="none"
                  d="
M177.653152,276.776733 
	C178.000977,277.662598 178.001968,278.323944 178.001831,278.985321 
	C178.000031,287.596069 178.003021,287.679993 169.545746,287.986603 
	C164.651428,288.164062 159.745438,288.019348 154.422653,288.009827 
	C153.991867,276.000793 153.992111,275.957123 165.943344,276.024139 
	C169.731705,276.045380 173.518356,276.367676 177.653152,276.776733 
z"
                />
                <path
                  fill="#D90940"
                  opacity="1.000000"
                  stroke="none"
                  d="
M305.588623,28.969891 
	C306.963898,33.971825 304.343719,36.505009 299.905243,37.397949 
	C293.305389,38.725723 286.655670,39.810867 280.012878,40.912918 
	C279.264252,41.037113 278.423096,40.603634 277.312439,40.214600 
	C281.395111,39.464546 283.443787,37.377838 283.311462,32.569962 
	C283.271057,31.101526 286.246155,28.337406 287.941803,28.254993 
	C293.662323,27.976961 299.428528,28.637671 305.588623,28.969891 
z"
                />
                <path
                  fill="#E01536"
                  opacity="1.000000"
                  stroke="none"
                  d="
M242.998779,24.000839 
	C242.997559,24.001677 243.218018,24.134199 243.218018,24.134199 
	C243.218018,24.134199 243.067154,24.120321 243.034378,24.058981 
	C243.001602,23.997641 243.000000,24.000000 242.998779,24.000839 
z"
                />
                <path
                  fill="#E01536"
                  opacity="1.000000"
                  stroke="none"
                  d="
M131.507141,73.508057 
	C131.486359,73.516006 131.527908,73.500099 131.507141,73.508057 
z"
                />
                <path
                  fill="#E01536"
                  opacity="1.000000"
                  stroke="none"
                  d="
M127.507072,75.508041 
	C127.486305,75.516006 127.527840,75.500076 127.507072,75.508041 
z"
                />
                <path
                  fill="#FDF9FC"
                  opacity="1.000000"
                  stroke="none"
                  d="
M89.922119,174.024216 
	C89.922119,183.164017 89.922119,192.303802 89.922119,201.858795 
	C68.454124,201.858795 47.075954,201.858795 25.117065,201.858795 
	C25.117065,170.654755 25.117065,139.266220 25.115662,107.400429 
	C33.957851,106.710602 42.801445,106.498039 52.289062,106.392578 
	C53.291470,106.694969 53.649853,106.890274 54.008240,107.085571 
	C54.008240,107.085571 54.012211,106.993507 53.925156,107.461075 
	C53.833645,115.895210 53.826622,123.861786 53.825333,131.828354 
	C53.823288,144.442123 53.799953,157.055984 53.849663,169.669571 
	C53.858070,171.802551 53.106895,175.015320 57.439125,173.211456 
	C57.582500,173.282623 57.879017,173.159042 58.122169,173.370209 
	C66.570366,173.461227 74.775414,173.341049 83.261551,173.430923 
	C85.374573,173.626450 87.206490,173.611923 89.233345,173.757904 
	C89.592888,173.953705 89.757500,173.988953 89.922119,174.024216 
z"
                />
                <path
                  fill="#DC0A3D"
                  opacity="1.000000"
                  stroke="none"
                  d="
M64.872581,107.122345 
	C65.248482,107.509514 65.259392,107.931358 64.927368,108.999008 
	C64.387268,117.429390 64.190094,125.213959 63.623028,133.071991 
	C58.991882,133.734894 57.929310,136.308075 57.864723,140.378662 
	C57.802666,144.289627 56.612980,148.182709 55.709915,151.721710 
	C55.372684,141.559357 55.244328,131.758942 55.115974,121.958527 
	C55.743938,119.895103 56.846714,117.847282 56.915096,115.765480 
	C57.168858,108.039780 57.040916,108.035576 64.872581,107.122345 
z"
                />
                <path
                  fill="#C81158"
                  opacity="1.000000"
                  stroke="none"
                  d="
M55.094715,121.505905 
	C55.244328,131.758942 55.372684,141.559357 55.718830,152.157806 
	C55.942554,157.957687 55.948490,162.959534 55.953331,168.364258 
	C56.400074,170.224869 56.847912,171.682587 57.295750,173.140305 
	C53.106895,175.015320 53.858070,171.802551 53.849663,169.669571 
	C53.799953,157.055984 53.823288,144.442123 53.825333,131.828354 
	C53.826622,123.861786 53.833645,115.895210 53.879131,107.458824 
	C54.304596,111.677094 54.689026,116.365189 55.094715,121.505905 
z"
                />
                <path
                  fill="#DD0A3C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M238.506104,21.510498 
	C238.485107,21.518505 238.527100,21.502489 238.506104,21.510498 
z"
                />
                <path
                  fill="#DD0A3C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M244.492844,18.491806 
	C244.513748,18.483761 244.471939,18.499851 244.492844,18.491806 
z"
                />
                <path
                  fill="#C81158"
                  opacity="1.000000"
                  stroke="none"
                  d="
M53.819321,106.834831 
	C53.649853,106.890274 53.291470,106.694969 52.713326,106.279953 
	C52.872513,106.234863 53.251457,106.409477 53.819321,106.834831 
z"
                />
                <path
                  fill="#DD0A3C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M74.000931,93.999344 
	C74.001869,93.998688 73.780640,93.865028 73.780640,93.865028 
	C73.780640,93.865028 73.933006,93.878586 73.965874,93.940224 
	C73.998741,94.001862 74.000000,94.000000 74.000931,93.999344 
z"
                />
                <path
                  fill="#DD0A3C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M160.492874,55.491806 
	C160.513779,55.483761 160.471970,55.499855 160.492874,55.491806 
z"
                />
                <path
                  fill="#DD0A3C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M119.490631,73.508675 
	C119.482773,73.487686 119.498489,73.529663 119.490631,73.508675 
z"
                />
                <path
                  fill="#CA1157"
                  opacity="1.000000"
                  stroke="none"
                  d="
M198.795731,107.944290 
	C199.131409,126.078026 199.480667,144.233917 199.141754,162.376953 
	C198.982910,170.879898 191.251404,177.131226 182.948349,176.711960 
	C174.467957,176.283722 168.054352,169.510483 167.990036,160.398529 
	C167.866562,142.901474 167.975662,125.402763 168.060028,107.436890 
	C168.750168,110.124481 169.784790,113.264488 169.902634,116.438530 
	C170.170654,123.657227 169.988358,130.892639 169.989227,139.032318 
	C169.989365,146.343536 169.989365,152.743713 169.989365,159.123215 
	C175.181412,159.611053 177.036530,157.570541 177.004395,153.436615 
	C176.985031,150.944214 177.004852,148.447586 177.128479,145.958878 
	C177.324005,142.022659 179.653397,140.439880 183.387512,140.532349 
	C186.858459,140.618271 190.483307,140.046494 191.176743,145.221207 
	C191.767990,149.633316 193.078598,153.949036 194.070984,158.307388 
	C194.520233,158.259613 194.969482,158.211838 195.418747,158.164062 
	C197.304840,141.507843 198.504654,124.807045 197.990555,107.994942 
	C198.169495,107.983688 198.348419,107.972427 198.795731,107.944290 
z"
                />
                <path
                  fill="#D20B4A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M197.666336,108.107178 
	C198.504654,124.807045 197.304840,141.507843 195.418747,158.164062 
	C194.969482,158.211838 194.520233,158.259613 194.070984,158.307388 
	C193.078598,153.949036 191.767990,149.633316 191.176743,145.221207 
	C190.483307,140.046494 186.858459,140.618271 183.387512,140.532349 
	C179.653397,140.439880 177.324005,142.022659 177.128479,145.958878 
	C177.004852,148.447586 176.985031,150.944214 177.004395,153.436615 
	C177.036530,157.570541 175.181412,159.611053 169.989365,159.123215 
	C169.989365,152.743713 169.989365,146.343536 169.990112,139.475800 
	C174.778366,132.888412 175.958725,125.704926 175.481583,118.289719 
	C175.122437,112.708107 176.146255,110.945824 181.819382,111.058304 
	C185.820938,111.137634 189.811920,111.751900 194.509567,112.193291 
	C194.995560,111.511475 196.168839,109.865448 197.666336,108.107178 
M195.337036,118.670929 
	C195.066666,117.941223 194.796310,117.211517 194.525955,116.481804 
	C194.103958,116.878036 193.681961,117.274261 193.259964,117.670494 
	C193.813309,118.143425 194.366638,118.616348 195.337036,118.670929 
z"
                />
                <path
                  fill="#D10C4B"
                  opacity="1.000000"
                  stroke="none"
                  d="
M200.138519,106.243256 
	C200.152390,106.411415 199.891357,106.736206 199.361725,107.224747 
	C199.349960,107.058960 199.606781,106.729424 200.138519,106.243256 
z"
                />
                <path
                  fill="#CC0E53"
                  opacity="1.000000"
                  stroke="none"
                  d="
M267.983765,105.074059 
	C267.162109,105.386978 265.955719,105.671822 264.371155,105.931458 
	C265.194977,105.619499 266.397003,105.332741 267.983765,105.074059 
z"
                />
                <path
                  fill="#D70A42"
                  opacity="1.000000"
                  stroke="none"
                  d="
M55.954422,167.961380 
	C55.948490,162.959534 55.942554,157.957687 55.927704,152.519745 
	C56.612980,148.182709 57.802666,144.289627 57.864723,140.378662 
	C57.929310,136.308075 58.991882,133.734894 63.650925,133.404755 
	C64.689323,134.446609 65.329926,135.229141 65.983116,136.001648 
	C65.995705,135.991608 65.996857,136.023575 66.159317,136.213898 
	C66.606682,136.576431 66.891594,136.748642 67.633972,136.908051 
	C75.298317,136.902863 82.510773,136.755829 89.708626,137.014618 
	C91.802475,137.089920 93.854607,138.325043 95.833710,139.133484 
	C95.618889,139.516922 95.665085,139.770126 95.898987,140.415771 
	C95.896004,142.226425 95.874184,143.619339 95.690079,145.234634 
	C95.636673,146.300583 95.745560,147.144180 95.876266,148.363754 
	C95.882339,149.492386 95.866600,150.245041 95.766571,151.112274 
	C95.576744,151.515625 95.633026,151.774109 95.873825,152.376450 
	C95.881294,153.499619 95.866066,154.248642 95.766617,155.112350 
	C95.577087,155.515945 95.633743,155.774368 95.870277,156.326813 
	C95.866653,157.083527 95.845100,157.515701 95.823547,157.947861 
	C95.823547,157.947861 95.400940,157.960876 94.875580,157.953430 
	C91.505257,154.443466 88.660286,150.940933 85.200783,146.681839 
	C83.912659,149.468994 82.410103,151.432983 82.164230,153.543381 
	C81.760414,157.009460 80.053391,157.787079 76.927658,158.086075 
	C72.034416,158.554184 67.145744,159.408615 62.373081,160.579941 
	C61.045563,160.905746 59.842243,162.777664 59.113850,164.210632 
	C58.392403,165.629944 58.342285,167.390503 57.741085,168.875427 
	C56.974445,168.486755 56.464436,168.224075 55.954422,167.961380 
z"
                />
                <path
                  fill="#D20D4B"
                  opacity="1.000000"
                  stroke="none"
                  d="
M57.997715,169.001389 
	C58.342285,167.390503 58.392403,165.629944 59.113850,164.210632 
	C59.842243,162.777664 61.045563,160.905746 62.373081,160.579941 
	C67.145744,159.408615 72.034416,158.554184 76.927658,158.086075 
	C80.053391,157.787079 81.760414,157.009460 82.164230,153.543381 
	C82.410103,151.432983 83.912659,149.468994 85.200783,146.681839 
	C88.660286,150.940933 91.505257,154.443466 94.664581,157.966522 
	C94.229301,171.627243 95.927452,185.385162 94.298820,198.983093 
	C93.534004,198.977127 92.769196,198.971176 92.004379,198.965210 
	C92.004379,192.763367 92.113213,186.558533 91.942253,180.361404 
	C91.886375,178.335922 91.102417,176.330536 90.286781,174.170074 
	C89.757500,173.988953 89.592888,173.953705 89.070885,173.480240 
	C86.802483,173.101639 84.891472,173.161255 82.980461,173.220871 
	C74.775414,173.341049 66.570366,173.461227 58.466644,173.120300 
	C65.318375,172.294403 72.068779,171.929611 78.819183,171.564819 
	C78.823456,171.042389 78.827736,170.519974 78.832016,169.997559 
	C76.129547,169.997559 73.420662,170.116028 70.726074,169.970337 
	C66.478249,169.740646 62.240009,169.333450 57.997715,169.001389 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M95.850861,150.997681 
	C95.866600,150.245041 95.882339,149.492386 95.920593,147.993164 
	C95.912857,146.501816 95.882614,145.757034 95.852364,145.012268 
	C95.874184,143.619339 95.896004,142.226425 95.927460,140.174316 
	C95.937080,139.515137 95.925858,139.028519 95.925858,139.028519 
	C93.854607,138.325043 91.802475,137.089920 89.708626,137.014618 
	C82.510773,136.755829 75.298317,136.902863 67.462250,136.725922 
	C66.584534,136.331543 66.305794,136.153870 65.996857,136.023575 
	C65.996857,136.023575 65.995705,135.991608 65.991646,135.713257 
	C65.998138,135.242874 66.008698,135.050842 66.019249,134.858826 
	C76.099289,134.858826 86.179329,134.858826 96.976952,134.858826 
	C96.976952,142.969345 96.976952,150.536240 96.871269,158.562561 
	C96.493736,158.844360 96.272293,158.617493 95.962402,158.144638 
	C95.845100,157.515701 95.866653,157.083527 95.888542,156.075775 
	C95.876205,155.332703 95.863525,155.165192 95.850845,154.997681 
	C95.866066,154.248642 95.881294,153.499619 95.892487,152.125427 
	C95.875923,151.332748 95.863396,151.165222 95.850861,150.997681 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M297.984802,174.762970 
	C297.644440,174.930389 297.364441,174.773315 297.067291,174.245850 
	C297.302765,174.204132 297.634460,174.391800 297.984802,174.762970 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M300.105042,176.835449 
	C299.773224,176.831894 299.487122,176.660477 299.127258,176.242706 
	C299.419250,176.220108 299.785004,176.443832 300.105042,176.835449 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M298.864838,175.755035 
	C298.639038,175.926926 298.370789,175.772461 298.124268,175.241547 
	C298.322449,175.156357 298.547913,175.344223 298.864838,175.755035 
z"
                />
                <path
                  fill="#BC1166"
                  opacity="1.000000"
                  stroke="none"
                  d="
M302.490845,174.508499 
	C302.483063,174.487701 302.498596,174.529297 302.490845,174.508499 
z"
                />
                <path
                  fill="#E74424"
                  opacity="1.000000"
                  stroke="none"
                  d="
M22.241213,27.159021 
	C26.584454,20.877958 33.142185,18.391403 40.290318,16.740749 
	C43.068035,16.099318 45.569317,14.301178 48.339207,13.571786 
	C50.300880,13.055220 52.502159,13.448550 54.799080,13.720568 
	C53.530083,19.137487 50.152309,21.351036 44.713577,20.528725 
	C41.816223,28.971292 33.351009,27.635504 27.010027,30.061106 
	C25.998554,30.448023 24.014967,28.293650 22.241213,27.159021 
M36.472771,21.499031 
	C36.472771,21.499031 36.513618,21.483175 36.472771,21.499031 
z"
                />
                <path
                  fill="#E94A21"
                  opacity="1.000000"
                  stroke="none"
                  d="
M57.489334,15.489282 
	C57.511398,15.480858 57.467266,15.497705 57.489334,15.489282 
z"
                />
                <path
                  fill="#E63B28"
                  opacity="1.000000"
                  stroke="none"
                  d="
M68.506973,8.510714 
	C68.486389,8.518734 68.527557,8.502693 68.506973,8.510714 
z"
                />
                <path
                  fill="#CB0F53"
                  opacity="1.000000"
                  stroke="none"
                  d="
M65.857178,134.488464 
	C66.008698,135.050842 65.998138,135.242874 65.979057,135.723297 
	C65.329926,135.229141 64.689323,134.446609 64.020821,133.331299 
	C64.190094,125.213959 64.387268,117.429390 64.820572,109.298080 
	C65.269501,117.340263 65.482307,125.729172 65.857178,134.488464 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M141.769501,175.807892 
	C141.520248,175.805252 141.312454,175.523193 141.114807,174.971024 
	C141.353607,174.976761 141.582275,175.252625 141.769501,175.807892 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M140.781464,172.842377 
	C140.542953,172.830582 140.353912,172.558884 140.194946,172.033722 
	C140.427002,172.047668 140.628967,172.315079 140.781464,172.842377 
z"
                />
                <path
                  fill="#B33F7A"
                  opacity="1.000000"
                  stroke="none"
                  d="
M140.282715,171.585495 
	C139.861649,171.796021 139.691559,171.573685 139.862335,171.053070 
	C140.085907,171.062729 140.196075,171.195343 140.282715,171.585495 
z"
                />
                <path
                  fill="#C30F5C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M137.719025,163.278534 
	C137.952011,163.770844 137.995209,164.517227 138.031830,165.638474 
	C137.848709,166.010956 137.672195,166.008606 137.230469,166.002197 
	C137.153275,165.176315 137.341263,164.354462 137.719025,163.278534 
z"
                />
                <path
                  fill="#DC0A3D"
                  opacity="1.000000"
                  stroke="none"
                  d="
M57.741085,168.875427 
	C62.240009,169.333450 66.478249,169.740646 70.726074,169.970337 
	C73.420662,170.116028 76.129547,169.997559 78.832016,169.997559 
	C78.827736,170.519974 78.823456,171.042389 78.819183,171.564819 
	C72.068779,171.929611 65.318375,172.294403 58.223492,172.909119 
	C57.879017,173.159042 57.582500,173.282623 57.439125,173.211456 
	C56.847912,171.682587 56.400074,170.224869 55.953331,168.364258 
	C56.464436,168.224075 56.974445,168.486755 57.741085,168.875427 
z"
                />
                <path
                  fill="#C91155"
                  opacity="1.000000"
                  stroke="none"
                  d="
M83.261551,173.430923 
	C84.891472,173.161255 86.802483,173.101639 88.875954,173.319702 
	C87.206490,173.611923 85.374573,173.626450 83.261551,173.430923 
z"
                />
                <path
                  fill="#D70942"
                  opacity="1.000000"
                  stroke="none"
                  d="
M195.128510,118.880096 
	C194.366638,118.616348 193.813309,118.143425 193.259964,117.670494 
	C193.681961,117.274261 194.103958,116.878036 194.525955,116.481812 
	C194.796310,117.211517 195.066666,117.941223 195.128510,118.880096 
z"
                />
                <path
                  fill="#C91155"
                  opacity="1.000000"
                  stroke="none"
                  d="
M95.690079,145.234634 
	C95.882614,145.757034 95.912857,146.501816 95.898773,147.617172 
	C95.745560,147.144180 95.636673,146.300583 95.690079,145.234634 
z"
                />
                <path
                  fill="#C91155"
                  opacity="1.000000"
                  stroke="none"
                  d="
M95.766617,155.112350 
	C95.863525,155.165192 95.876205,155.332703 95.870613,155.751221 
	C95.633743,155.774368 95.577087,155.515945 95.766617,155.112350 
z"
                />
                <path
                  fill="#C91155"
                  opacity="1.000000"
                  stroke="none"
                  d="
M95.766571,151.112274 
	C95.863396,151.165222 95.875923,151.332748 95.869797,151.751282 
	C95.633026,151.774109 95.576744,151.515625 95.766571,151.112274 
z"
                />
                <path
                  fill="#C91155"
                  opacity="1.000000"
                  stroke="none"
                  d="
M95.833710,139.133484 
	C95.925858,139.028519 95.937080,139.515137 95.908615,139.756592 
	C95.665085,139.770126 95.618889,139.516922 95.833710,139.133484 
z"
                />
                <path
                  fill="#CB0F53"
                  opacity="1.000000"
                  stroke="none"
                  d="
M66.159317,136.213898 
	C66.305794,136.153870 66.584534,136.331543 67.004791,136.738724 
	C66.891594,136.748642 66.606682,136.576431 66.159317,136.213898 
z"
                />
                <path
                  fill="#E94A21"
                  opacity="1.000000"
                  stroke="none"
                  d="
M36.493195,21.491104 
	C36.513618,21.483175 36.472771,21.499031 36.493195,21.491104 
z"
                />
              </svg>
              <p style={{ fontWeight: "bold", fontSize: "2rem" }}>LTUC</p>
              <div className="project-links">
                <a
                  href="https://www.ltuc.com/"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Software Engineer and TA</h3>
              <p>
                At Luminus Technical University College, I worked as a
                full-stack developer on internal projects, including a staff
                tracker and a custom full-stack Discord-based system for TA
                analysis and tracking. In addition to my development role, I
                also contributed to the academic side as a Teaching Assistant
                for various programming courses, supporting students in their
                learning journey.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>December 26, 2021</li> <li>⟶</li> <li>March 9, 2023</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn" duration={3}>
          <div className="project">
            <header>
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="50"
                viewBox="0 0 600 600"
                enableBackground="new 0 0 600 600"
              >
                <path
                  fill="#FFFFFF"
                  opacity="1.000000"
                  stroke="none"
                  d="
M400.000000,601.000000 
	C266.666656,601.000000 133.833328,601.000000 1.000000,601.000000 
	C1.000000,401.000000 1.000000,201.000000 1.000000,1.000000 
	C201.000000,1.000000 401.000000,1.000000 601.000000,1.000000 
	C601.000000,201.000000 601.000000,401.000000 601.000000,601.000000 
	C534.166687,601.000000 467.333344,601.000000 400.000000,601.000000 
M475.923737,270.284363 
	C481.949799,270.210968 487.975861,270.137573 494.919220,270.277100 
	C511.296906,270.208923 527.674561,270.140747 544.975708,270.197296 
	C553.548218,270.197296 562.120789,270.197296 570.608582,270.197296 
	C570.608582,253.589218 570.608582,237.853271 570.608582,221.790390 
	C561.581970,221.790390 552.935974,221.790390 544.172424,221.660110 
	C544.172424,221.660110 544.012756,221.587280 544.061707,220.702820 
	C544.061707,195.673904 544.061707,170.644989 544.061707,145.110092 
	C526.850708,145.110092 510.421173,145.110092 493.893188,144.159821 
	C493.882355,135.894806 493.665741,127.622810 493.945892,119.367668 
	C494.090027,115.120483 492.502594,113.896286 488.488525,114.091713 
	C484.050079,114.307800 479.583588,113.948814 475.093781,112.924019 
	C475.093781,106.482727 475.093781,100.041428 475.093781,93.392181 
	C441.556305,93.392181 408.577240,93.392181 375.408173,93.392181 
	C375.408173,100.860970 375.408173,107.974625 375.263580,116.002121 
	C375.340912,125.682487 375.418274,135.362854 375.285004,145.950897 
	C375.357178,162.638824 375.429382,179.326752 375.288696,196.927902 
	C375.349731,205.298309 375.410797,213.668716 375.278931,222.951752 
	C375.140625,238.595795 375.002319,254.239838 374.023132,270.229218 
	C340.504913,270.229218 306.986694,270.229218 273.571228,270.229218 
	C273.571228,279.743286 273.571228,288.328583 273.571228,296.907898 
	C307.593323,296.907898 341.283295,296.907898 374.748962,296.907898 
	C374.748962,287.636353 374.748962,278.709900 375.637665,270.207581 
	C396.093689,270.162750 416.549683,270.117889 437.920197,270.295807 
	C450.282776,270.221558 462.645386,270.147278 475.923737,270.284363 
M154.067322,426.496582 
	C158.004654,415.168854 158.555359,403.545746 155.787048,392.010437 
	C151.555161,374.376434 142.331039,360.821289 123.346970,356.613251 
	C113.778229,354.492249 104.848793,357.086609 96.345627,361.407471 
	C91.216644,364.013733 86.166000,366.774200 80.297653,369.879425 
	C80.297653,364.790527 80.297653,360.551788 80.297653,355.904327 
	C62.400501,355.648163 47.526352,364.671143 31.288975,368.071014 
	C31.288975,371.825317 31.288975,375.066772 31.288975,378.802551 
	C36.154697,378.802551 40.736790,378.802551 45.605370,378.802551 
	C45.605370,394.281097 45.605438,409.257202 45.605350,424.233307 
	C45.605225,445.895691 45.541519,467.558411 45.656719,489.220184 
	C45.680630,493.716217 44.248806,496.155670 39.411938,496.110077 
	C36.783321,496.085236 34.149609,496.600769 31.475626,496.877014 
	C31.475626,500.664185 31.475626,504.096222 31.475626,507.742065 
	C53.147972,507.742065 74.576805,507.742065 96.445885,507.742065 
	C96.445885,504.120361 96.445885,500.584045 96.445885,496.807922 
	C93.023354,496.529175 89.715248,496.120392 86.398132,496.025055 
	C82.281418,495.906769 80.334457,494.062103 80.425697,489.855682 
	C80.548546,484.192810 80.454941,478.525269 80.454536,472.859711 
	C80.454262,468.956909 80.454491,465.054108 80.454491,461.936066 
	C88.330063,461.936066 95.341827,462.341614 102.292587,461.862366 
	C126.038147,460.225098 144.460861,450.399170 154.067322,426.496582 
M219.011902,406.431732 
	C216.006638,412.085785 213.001373,417.739838 209.449677,424.421936 
	C207.130569,401.127869 208.770996,378.760132 204.296310,356.754486 
	C186.604828,355.409332 170.966354,362.554016 154.448761,365.149445 
	C154.448761,368.277130 154.448761,370.882050 154.448761,373.718719 
	C161.298126,374.887665 167.963440,376.025177 174.876190,377.204926 
	C175.612335,393.948303 176.523468,410.395813 176.995071,426.855865 
	C177.326370,438.419037 177.059082,449.999390 177.059082,462.022552 
	C183.517685,462.022552 190.497299,461.805206 197.454086,462.109314 
	C201.235123,462.274658 203.314117,461.197266 205.175873,457.682922 
	C216.005875,437.239746 227.152512,416.964264 238.198502,396.635559 
	C239.030670,395.104065 239.912857,393.599731 240.771790,392.082794 
	C241.084396,392.156281 241.397018,392.229767 241.709641,392.303253 
	C243.273254,415.421204 244.836868,438.539124 246.424927,462.018372 
	C254.317200,462.018372 261.786530,462.144043 269.243958,461.902222 
	C270.582153,461.858826 272.189819,460.558289 273.134430,459.399231 
	C284.814178,445.067841 296.713745,430.897247 307.873688,416.167755 
	C314.076141,407.981415 319.674103,399.163574 324.257812,389.987610 
	C327.126801,384.244415 328.422424,377.370087 328.930603,370.886261 
	C329.479126,363.886902 324.660400,358.635895 317.796021,356.775818 
	C310.979706,354.928802 304.459625,355.772034 298.976746,360.399017 
	C297.571442,361.584961 296.536072,364.207245 296.688782,366.057526 
	C297.180847,372.018921 297.584503,378.151581 299.336426,383.811401 
	C303.154236,396.145569 300.163422,406.104645 291.644012,415.528656 
	C285.725098,422.076141 281.114044,429.805969 275.077881,438.173126 
	C273.679932,410.878662 272.359192,385.091980 271.026123,359.064178 
	C260.101074,359.960388 249.904510,360.796814 240.945251,361.531769 
	C239.247604,366.112457 238.279770,369.785583 236.589890,373.089325 
	C230.981506,384.053833 225.113297,394.885437 219.011902,406.431732 
M345.796143,450.706390 
	C352.701141,457.134613 360.885132,461.041901 370.126221,462.590363 
	C390.761444,466.048065 410.167847,461.702057 428.779327,452.874756 
	C429.730408,452.423584 430.780243,451.006836 430.819031,450.002380 
	C431.022217,444.739899 430.913971,439.465393 430.913971,433.946899 
	C423.212738,436.915741 416.118622,440.196320 408.703857,442.396027 
	C392.955322,447.068146 379.145844,441.831970 372.498535,428.375977 
	C365.061157,413.320648 365.267059,397.732483 372.173645,382.535187 
	C376.251740,373.561859 383.940369,368.953674 394.099945,367.464233 
	C394.099945,373.708710 394.099976,379.514130 394.099945,385.319580 
	C394.099945,396.065338 395.473846,397.780884 406.372070,399.448059 
	C409.279999,399.892914 412.392792,399.888916 415.286438,399.379852 
	C426.877045,397.340820 432.690277,387.568085 429.085938,376.290131 
	C426.052460,366.798431 418.550201,362.046417 409.739349,359.037537 
	C398.767639,355.290710 387.460144,355.045959 376.177002,357.094482 
	C354.833313,360.969604 338.450043,371.701965 331.774139,393.178131 
	C325.146393,414.499634 328.994568,433.998627 345.796143,450.706390 
z"
                />
                <path
                  fill="#020202"
                  opacity="1.000000"
                  stroke="none"
                  d="
M153.955353,426.871674 
	C144.460861,450.399170 126.038147,460.225098 102.292587,461.862366 
	C95.341827,462.341614 88.330063,461.936066 80.454491,461.936066 
	C80.454491,465.054108 80.454262,468.956909 80.454536,472.859711 
	C80.454941,478.525269 80.548546,484.192810 80.425697,489.855682 
	C80.334457,494.062103 82.281418,495.906769 86.398132,496.025055 
	C89.715248,496.120392 93.023354,496.529175 96.445885,496.807922 
	C96.445885,500.584045 96.445885,504.120361 96.445885,507.742065 
	C74.576805,507.742065 53.147972,507.742065 31.475626,507.742065 
	C31.475626,504.096222 31.475626,500.664185 31.475626,496.877014 
	C34.149609,496.600769 36.783321,496.085236 39.411938,496.110077 
	C44.248806,496.155670 45.680630,493.716217 45.656719,489.220184 
	C45.541519,467.558411 45.605225,445.895691 45.605350,424.233307 
	C45.605438,409.257202 45.605370,394.281097 45.605370,378.802551 
	C40.736790,378.802551 36.154697,378.802551 31.288975,378.802551 
	C31.288975,375.066772 31.288975,371.825317 31.288975,368.071014 
	C47.526352,364.671143 62.400501,355.648163 80.297653,355.904327 
	C80.297653,360.551788 80.297653,364.790527 80.297653,369.879425 
	C86.166000,366.774200 91.216644,364.013733 96.345627,361.407471 
	C104.848793,357.086609 113.778229,354.492249 123.346970,356.613251 
	C142.331039,360.821289 151.555161,374.376434 155.787048,392.010437 
	C158.555359,403.545746 158.004654,415.168854 153.955353,426.871674 
M98.293976,379.049103 
	C93.979767,379.027832 89.663658,379.078125 85.351936,378.963409 
	C81.651886,378.864990 80.272972,380.144592 80.321342,384.199951 
	C80.561394,404.326385 80.424835,424.457275 80.443718,444.586578 
	C80.445053,446.015900 80.629364,447.445007 80.722260,448.783081 
	C98.218132,451.534088 111.611259,443.989075 116.480949,428.620514 
	C119.661507,418.582794 119.938889,408.314667 117.469925,398.076477 
	C115.095993,388.232391 109.338043,381.488434 98.293976,379.049103 
z"
                />
                <path
                  fill="#040404"
                  opacity="1.000000"
                  stroke="none"
                  d="
M219.178314,406.099854 
	C225.113297,394.885437 230.981506,384.053833 236.589890,373.089325 
	C238.279770,369.785583 239.247604,366.112457 240.945251,361.531769 
	C249.904510,360.796814 260.101074,359.960388 271.026123,359.064178 
	C272.359192,385.091980 273.679932,410.878662 275.077881,438.173126 
	C281.114044,429.805969 285.725098,422.076141 291.644012,415.528656 
	C300.163422,406.104645 303.154236,396.145569 299.336426,383.811401 
	C297.584503,378.151581 297.180847,372.018921 296.688782,366.057526 
	C296.536072,364.207245 297.571442,361.584961 298.976746,360.399017 
	C304.459625,355.772034 310.979706,354.928802 317.796021,356.775818 
	C324.660400,358.635895 329.479126,363.886902 328.930603,370.886261 
	C328.422424,377.370087 327.126801,384.244415 324.257812,389.987610 
	C319.674103,399.163574 314.076141,407.981415 307.873688,416.167755 
	C296.713745,430.897247 284.814178,445.067841 273.134430,459.399231 
	C272.189819,460.558289 270.582153,461.858826 269.243958,461.902222 
	C261.786530,462.144043 254.317200,462.018372 246.424927,462.018372 
	C244.836868,438.539124 243.273254,415.421204 241.709641,392.303253 
	C241.397018,392.229767 241.084396,392.156281 240.771790,392.082794 
	C239.912857,393.599731 239.030670,395.104065 238.198502,396.635559 
	C227.152512,416.964264 216.005875,437.239746 205.175873,457.682922 
	C203.314117,461.197266 201.235123,462.274658 197.454086,462.109314 
	C190.497299,461.805206 183.517685,462.022552 177.059082,462.022552 
	C177.059082,449.999390 177.326370,438.419037 176.995071,426.855865 
	C176.523468,410.395813 175.612335,393.948303 174.876190,377.204926 
	C167.963440,376.025177 161.298126,374.887665 154.448761,373.718719 
	C154.448761,370.882050 154.448761,368.277130 154.448761,365.149445 
	C170.966354,362.554016 186.604828,355.409332 204.296310,356.754486 
	C208.770996,378.760132 207.130569,401.127869 209.449677,424.421936 
	C213.001373,417.739838 216.006638,412.085785 219.178314,406.099854 
z"
                />
                <path
                  fill="#040404"
                  opacity="1.000000"
                  stroke="none"
                  d="
M345.540405,450.462952 
	C328.994568,433.998627 325.146393,414.499634 331.774139,393.178131 
	C338.450043,371.701965 354.833313,360.969604 376.177002,357.094482 
	C387.460144,355.045959 398.767639,355.290710 409.739349,359.037537 
	C418.550201,362.046417 426.052460,366.798431 429.085938,376.290131 
	C432.690277,387.568085 426.877045,397.340820 415.286438,399.379852 
	C412.392792,399.888916 409.279999,399.892914 406.372070,399.448059 
	C395.473846,397.780884 394.099945,396.065338 394.099945,385.319580 
	C394.099976,379.514130 394.099945,373.708710 394.099945,367.464233 
	C383.940369,368.953674 376.251740,373.561859 372.173645,382.535187 
	C365.267059,397.732483 365.061157,413.320648 372.498535,428.375977 
	C379.145844,441.831970 392.955322,447.068146 408.703857,442.396027 
	C416.118622,440.196320 423.212738,436.915741 430.913971,433.946899 
	C430.913971,439.465393 431.022217,444.739899 430.819031,450.002380 
	C430.780243,451.006836 429.730408,452.423584 428.779327,452.874756 
	C410.167847,461.702057 390.761444,466.048065 370.126221,462.590363 
	C360.885132,461.041901 352.701141,457.134613 345.540405,450.462952 
z"
                />
                <path
                  fill="#DB6127"
                  opacity="1.000000"
                  stroke="none"
                  d="
M375.501587,196.014679 
	C375.429382,179.326752 375.357178,162.638824 375.824829,145.487946 
	C409.251099,145.011078 442.137482,144.997147 475.019714,144.969727 
	C475.015533,144.956253 475.044159,144.950378 475.027679,145.423340 
	C475.047241,171.169495 475.083282,196.442703 475.087036,221.786194 
	C475.054718,221.856476 475.000000,222.001221 474.531494,221.986496 
	C461.723572,221.965973 449.384155,221.960159 437.052856,221.936478 
	C437.060974,221.918610 437.059021,221.879379 437.042175,221.423004 
	C437.016968,214.300293 436.779175,207.623383 437.085876,200.971573 
	C437.270874,196.959747 435.921326,195.884598 431.998505,195.923889 
	C413.167786,196.112473 394.334167,196.012299 375.501587,196.014679 
z"
                />
                <path
                  fill="#F1BB39"
                  opacity="1.000000"
                  stroke="none"
                  d="
M493.991638,145.110092 
	C510.421173,145.110092 526.850708,145.110092 544.061707,145.110092 
	C544.061707,170.644989 544.061707,195.673904 543.582153,221.258759 
	C526.758118,221.847397 510.413727,221.880096 494.100250,221.882294 
	C494.131165,221.851807 494.126099,221.763474 494.083069,221.320740 
	C493.992218,195.810730 493.944397,170.743484 493.941498,145.538239 
	C493.986450,145.400269 493.991638,145.110092 493.991638,145.110092 
z"
                />
                <path
                  fill="#E6782C"
                  opacity="1.000000"
                  stroke="none"
                  d="
M475.023895,144.983215 
	C442.137482,144.997147 409.251099,145.011078 375.930176,145.034119 
	C375.418274,135.362854 375.340912,125.682487 375.774597,115.513489 
	C409.166443,115.031830 442.047241,115.038803 474.973022,115.508705 
	C475.019958,125.642166 475.021912,135.312698 475.023895,144.983215 
z"
                />
                <path
                  fill="#AC2323"
                  opacity="1.000000"
                  stroke="none"
                  d="
M437.005707,270.073059 
	C416.549683,270.117889 396.093689,270.162750 375.222351,270.020325 
	C374.807007,269.833099 374.864014,269.883881 374.864014,269.883881 
	C375.002319,254.239838 375.140625,238.595795 375.812500,222.483795 
	C396.583740,221.970367 416.821381,221.924881 437.059021,221.879395 
	C437.059021,221.879379 437.060974,221.918610 437.036926,222.409882 
	C437.010468,238.625122 437.008087,254.349091 437.005707,270.073059 
z"
                />
                <path
                  fill="#AC2323"
                  opacity="1.000000"
                  stroke="none"
                  d="
M374.777985,269.808289 
	C374.748962,278.709900 374.748962,287.636353 374.748962,296.907898 
	C341.283295,296.907898 307.593323,296.907898 273.571228,296.907898 
	C273.571228,288.328583 273.571228,279.743286 273.571228,270.229218 
	C306.986694,270.229218 340.504913,270.229218 374.443573,270.056549 
	C374.864014,269.883881 374.807007,269.833099 374.777985,269.808289 
z"
                />
                <path
                  fill="#E05929"
                  opacity="1.000000"
                  stroke="none"
                  d="
M494.069336,221.912781 
	C510.413727,221.880096 526.758118,221.847397 543.557617,221.700989 
	C544.012756,221.587280 544.172424,221.660110 544.139771,222.202484 
	C544.088806,238.520752 544.070496,254.296661 544.052246,270.072571 
	C527.674561,270.140747 511.296906,270.208923 494.458862,269.697327 
	C494.022125,253.382629 494.045746,237.647705 494.069336,221.912781 
z"
                />
                <path
                  fill="#EC9C4F"
                  opacity="1.000000"
                  stroke="none"
                  d="
M474.928070,115.045769 
	C442.047241,115.038803 409.166443,115.031830 375.846893,115.056572 
	C375.408173,107.974625 375.408173,100.860970 375.408173,93.392181 
	C408.577240,93.392181 441.556305,93.392181 475.093781,93.392181 
	C475.093781,100.041428 475.093781,106.482727 475.051849,113.682083 
	C474.982635,114.642029 474.955353,114.843903 474.928070,115.045769 
z"
                />
                <path
                  fill="#C32E26"
                  opacity="1.000000"
                  stroke="none"
                  d="
M437.462952,270.184448 
	C437.008087,254.349091 437.010468,238.625122 437.028778,222.427750 
	C449.384155,221.960159 461.723572,221.965973 474.532227,222.455017 
	C475.003632,238.649857 475.005798,254.361435 475.007965,270.073029 
	C462.645386,270.147278 450.282776,270.221558 437.462952,270.184448 
z"
                />
                <path
                  fill="#C24D27"
                  opacity="1.000000"
                  stroke="none"
                  d="
M437.042175,221.423004 
	C416.821381,221.924881 396.583740,221.970367 375.908997,222.027496 
	C375.410797,213.668716 375.349731,205.298309 375.395142,196.471283 
	C394.334167,196.012299 413.167786,196.112473 431.998505,195.923889 
	C435.921326,195.884598 437.270874,196.959747 437.085876,200.971573 
	C436.779175,207.623383 437.016968,214.300293 437.042175,221.423004 
z"
                />
                <path
                  fill="#E76DA7"
                  opacity="1.000000"
                  stroke="none"
                  d="
M544.513977,270.134949 
	C544.070496,254.296661 544.088806,238.520752 544.198547,222.267609 
	C552.935974,221.790390 561.581970,221.790390 570.608582,221.790390 
	C570.608582,237.853271 570.608582,253.589218 570.608582,270.197296 
	C562.120789,270.197296 553.548218,270.197296 544.513977,270.134949 
z"
                />
                <path
                  fill="#D54627"
                  opacity="1.000000"
                  stroke="none"
                  d="
M475.465851,270.178711 
	C475.005798,254.361435 475.003632,238.649857 475.000732,222.469742 
	C475.000000,222.001221 475.054718,221.856476 475.537903,221.865860 
	C482.056122,221.837982 488.091095,221.800735 494.126099,221.763474 
	C494.126099,221.763474 494.131165,221.851807 494.100250,221.882294 
	C494.045746,237.647705 494.022125,253.382629 494.000244,269.590881 
	C487.975861,270.137573 481.949799,270.210968 475.465851,270.178711 
z"
                />
                <path
                  fill="#F3BC87"
                  opacity="1.000000"
                  stroke="none"
                  d="
M474.973022,115.508705 
	C474.955353,114.843903 474.982635,114.642029 475.069641,114.140213 
	C479.583588,113.948814 484.050079,114.307800 488.488525,114.091713 
	C492.502594,113.896286 494.090027,115.120483 493.945892,119.367668 
	C493.665741,127.622810 493.882355,135.894806 493.942413,144.634949 
	C493.991638,145.110092 493.986450,145.400269 493.511292,145.345123 
	C487.038818,145.176773 481.041504,145.063583 475.044159,144.950378 
	C475.044159,144.950378 475.015533,144.956253 475.019714,144.969727 
	C475.021912,135.312698 475.019958,125.642166 474.973022,115.508705 
z"
                />
                <path
                  fill="#FAFAFA"
                  opacity="1.000000"
                  stroke="none"
                  d="
M98.701447,379.117554 
	C109.338043,381.488434 115.095993,388.232391 117.469925,398.076477 
	C119.938889,408.314667 119.661507,418.582794 116.480949,428.620514 
	C111.611259,443.989075 98.218132,451.534088 80.722260,448.783081 
	C80.629364,447.445007 80.445053,446.015900 80.443718,444.586578 
	C80.424835,424.457275 80.561394,404.326385 80.321342,384.199951 
	C80.272972,380.144592 81.651886,378.864990 85.351936,378.963409 
	C89.663658,379.078125 93.979767,379.027832 98.701447,379.117554 
z"
                />
                <path
                  fill="#E98E2B"
                  opacity="1.000000"
                  stroke="none"
                  d="
M475.027679,145.423340 
	C481.041504,145.063583 487.038818,145.176773 493.466370,145.483093 
	C493.944397,170.743484 493.992218,195.810730 494.083069,221.320740 
	C488.091095,221.800735 482.056122,221.837982 475.570221,221.795578 
	C475.083282,196.442703 475.047241,171.169495 475.027679,145.423340 
z"
                />
              </svg>
              <p style={{ fontWeight: "bold", fontSize: "2rem" }}>PwC</p>
              <div className="project-links">
                <a
                  href="https://www.pwc.com/gx/en.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Full Stack Developer Consultant</h3>
              <p>
                At PwC Jordan, I worked as a full-stack developer specializing
                in React and Node.js. I contributed to TAMM, a large-scale
                project for the Abu Dhabi government, focusing on building
                efficient, scalable, and high-performance solutions.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>April 1, 2021</li> <li>⟶</li> <li>December 23, 2021</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn" duration={3}>
          <div className="project">
            <header>
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="50"
                viewBox="0 0 200 200"
                enableBackground="new 0 0 200 200"
              >
                <path
                  fill="#FEFDFA"
                  opacity="1.000000"
                  stroke="none"
                  d="
M1.000000,55.000000 
	C1.000000,36.666672 1.000000,18.833342 1.000000,1.000010 
	C67.666649,1.000006 134.333298,1.000006 200.999954,1.000003 
	C200.999969,67.666634 200.999969,134.333267 200.999985,200.999908 
	C134.333389,200.999939 67.666771,200.999939 1.000078,200.999969 
	C1.000000,152.500000 1.000000,104.000000 1.000000,55.000000 
M57.797485,104.130836 
	C58.029861,103.851547 58.262238,103.572258 58.792419,103.224258 
	C58.792419,103.224258 58.997959,102.998070 59.662041,102.911537 
	C61.430061,101.265907 63.198082,99.620285 65.000000,98.000305 
	C65.000000,98.000305 64.975868,97.965416 65.552444,97.831322 
	C66.094238,97.285133 66.636032,96.738937 67.071457,95.986649 
	C67.071457,95.986649 67.159569,96.199409 67.671387,96.082123 
	C67.863731,95.803276 68.056076,95.524422 67.981071,95.152878 
	C67.981071,95.152878 68.244064,95.264648 68.727081,95.162544 
	C69.049080,95.009796 69.245026,94.758713 69.347252,94.343597 
	C69.347252,94.343597 69.420433,94.345688 69.864761,94.220650 
	C70.151161,94.051208 70.314125,93.801277 70.378685,93.395790 
	C70.378685,93.395790 70.453949,93.420273 71.081230,93.300385 
	C72.150902,92.314438 73.220573,91.328491 74.201942,90.341805 
	C74.201942,90.341805 74.273766,90.290413 74.809021,90.144264 
	C75.044220,89.865326 75.279427,89.586395 75.805946,89.250130 
	C75.805946,89.250130 76.004539,89.029411 76.659485,88.938881 
	C77.879906,87.762665 79.100334,86.586456 80.101593,85.276924 
	C80.101593,85.276924 80.344231,85.360184 80.997406,85.222733 
	C82.471588,83.900650 83.945763,82.578568 85.742996,81.149467 
	C85.742996,81.149467 85.969467,80.895439 86.615257,80.840240 
	C87.505486,79.949760 88.395706,79.059288 89.844849,77.969254 
	C90.563347,77.311516 91.281845,76.653786 92.655502,75.910942 
	C94.101730,74.606285 95.547958,73.301636 97.000000,72.000000 
	C97.000000,72.000000 96.997948,71.993813 97.503960,71.874565 
	C97.682220,71.590233 97.860481,71.305893 97.998764,71.000717 
	C97.998764,71.000717 98.025032,71.037506 98.677650,70.938187 
	C100.115997,69.621727 101.554337,68.305260 103.446823,66.826126 
	C103.739639,66.656395 103.937386,66.410263 104.678146,65.976364 
	C105.546486,65.091972 106.414833,64.207588 107.304146,63.091171 
	C107.304146,63.091171 107.250793,63.317482 107.837242,63.238358 
	C108.239449,62.837563 108.641663,62.436768 108.998123,62.002464 
	C108.998123,62.002464 109.033478,62.047451 109.667267,61.956944 
	C110.533607,61.077187 111.399956,60.197430 112.139107,59.221638 
	C112.139107,59.221638 112.257988,59.303848 112.928154,59.194599 
	C114.720932,57.591270 116.513710,55.987942 118.029572,54.322311 
	C118.029572,54.322311 118.311890,54.349789 118.880775,54.245518 
	C119.259079,53.833839 119.637390,53.422165 120.000000,52.999542 
	C120.000000,52.999542 120.009148,53.016033 120.647736,52.939281 
	C121.519600,52.061062 122.391464,51.182842 123.221245,50.303867 
	C123.221245,50.303867 123.240601,50.266567 123.788254,50.134979 
	C124.020279,49.847473 124.252304,49.559967 124.780495,49.198936 
	C124.780495,49.198936 124.978912,48.967117 125.640701,48.888420 
	C126.909065,47.682236 128.177429,46.476051 129.756516,45.177197 
	C129.756516,45.177197 129.974930,44.937534 130.554062,44.820717 
	C131.075272,44.251232 131.596481,43.681744 132.035202,43.003208 
	C132.035202,43.003208 132.087036,43.129692 132.609085,43.025848 
	C132.811172,42.749214 133.013245,42.472580 133.003128,42.066189 
	C133.003128,42.066189 133.196289,42.223007 133.689362,42.088146 
	C133.879761,41.817173 134.070175,41.546200 133.992432,41.190266 
	C133.992432,41.190266 134.246994,41.310055 134.829315,41.222118 
	C135.221786,40.817120 135.614243,40.412125 136.000000,40.000000 
	C136.000000,40.000000 136.006744,40.007431 136.655289,39.911190 
	C137.875549,38.742641 139.095810,37.574093 140.053802,36.314175 
	C140.053802,36.314175 140.327286,36.362514 140.893051,36.253113 
	C141.265839,35.838509 141.638626,35.423908 142.000000,35.000000 
	C142.000000,35.000000 142.008438,35.012203 142.621292,34.943520 
	C143.153824,34.370201 143.686356,33.796883 144.126358,33.030258 
	C144.126358,33.030258 144.175613,33.238827 144.800842,33.137024 
	C145.518219,32.412899 146.235596,31.688774 147.000000,30.999300 
	C147.000000,30.999300 146.966995,30.951067 147.665329,30.859953 
	C149.850616,30.120871 152.035904,29.381788 154.221176,28.642710 
	C154.793335,30.949230 155.859146,33.254608 155.864471,35.562435 
	C155.962906,78.171448 155.945511,120.780754 155.922318,163.389984 
	C155.918549,170.335678 154.070862,171.419693 147.777542,168.583710 
	C139.609238,164.902817 131.386978,161.341629 122.964691,157.855347 
	C122.964691,157.855347 123.194565,157.747803 122.850784,157.186859 
	C119.528183,154.493530 117.344307,155.339142 115.994316,159.282394 
	C115.100380,161.893524 114.016251,164.439560 112.807899,167.289749 
	C112.807899,167.289749 112.772720,167.633591 112.217850,168.062439 
	C111.750404,169.343719 111.282951,170.625000 110.959290,171.956345 
	C110.959290,171.956345 110.840263,171.861404 110.274109,172.237564 
	C107.527779,177.930939 104.781456,183.624313 101.934525,189.526230 
	C103.406128,189.899780 103.880447,190.125687 104.354622,190.125381 
	C125.080177,190.111877 145.807159,190.189636 166.529633,189.921234 
	C169.467712,189.883179 172.383820,188.149323 175.839340,187.153091 
	C176.284546,186.887405 176.729736,186.621719 177.779480,186.260040 
	C178.200974,185.852280 178.622467,185.444519 178.999237,185.001068 
	C178.999237,185.001068 179.033051,185.047485 179.713257,184.986557 
	C181.489777,183.000748 183.266281,181.014923 185.000565,178.999527 
	C185.000565,178.999527 185.031723,179.040466 185.672043,178.758270 
	C187.156097,174.087463 189.892914,169.426208 189.928619,164.744354 
	C190.252670,122.263451 190.199875,79.778351 189.935837,37.296474 
	C189.911774,33.424755 187.647171,29.566961 186.182098,25.872862 
	C186.182098,25.872862 186.388046,25.661716 186.306824,25.016966 
	C185.534836,24.016459 184.762848,23.015951 184.000610,21.999813 
	C184.000610,21.999813 183.984833,22.009037 183.829300,21.453056 
	C183.354797,21.168198 182.880295,20.883339 182.343002,20.564583 
	C182.343002,20.564583 182.369202,20.498198 182.207245,19.906807 
	C181.255875,19.165865 180.304504,18.424923 179.269424,17.757591 
	C179.269424,17.757591 179.279968,17.646618 178.977966,17.053560 
	C173.841858,15.437027 168.717789,12.463832 163.567734,12.418155 
	C121.601532,12.045947 79.630257,12.170309 37.661293,12.337758 
	C34.712391,12.349524 31.769661,13.909879 29.010885,14.842450 
	C29.010885,14.842450 28.825909,14.733779 28.115005,14.725763 
	C26.944708,15.402075 25.774408,16.078386 24.273006,16.809319 
	C24.273006,16.809319 24.011621,17.019772 23.329031,17.075958 
	C21.119015,19.638906 18.909000,22.201855 17.008333,24.863665 
	C17.008333,24.863665 16.701920,24.747505 16.086439,25.033875 
	C15.637166,26.301138 15.187894,27.568401 14.874666,29.039675 
	C14.874666,29.039675 14.756558,28.827997 14.153769,29.250216 
	C13.501466,33.133015 12.295992,37.013844 12.282160,40.898914 
	C12.138860,81.145836 12.171618,121.393471 12.222331,161.640823 
	C12.225419,164.092377 12.794291,166.543213 13.082946,169.656174 
	C13.214039,170.074493 13.345132,170.492798 13.329041,171.607788 
	C14.756330,174.171021 16.183619,176.734253 17.671051,179.327332 
	C17.671051,179.327332 17.658607,179.393326 17.777437,180.028702 
	C18.844339,181.035706 19.911240,182.042694 21.205723,183.472061 
	C21.406347,183.737228 21.666477,183.915665 22.212582,184.605957 
	C23.124542,185.102814 24.036505,185.599686 24.992861,186.009109 
	C24.992861,186.009109 24.919794,186.074509 25.282223,186.687439 
	C34.302460,192.087921 44.256580,189.616562 53.862110,189.983978 
	C54.569534,190.011032 55.644466,189.017181 55.998936,188.245499 
	C57.847710,184.220779 59.518597,180.114365 61.433361,175.843063 
	C61.433361,175.843063 61.433712,175.577591 61.988644,175.168884 
	C64.082268,170.502594 66.175896,165.836319 68.061203,160.981888 
	C68.061203,160.981888 68.250404,161.188873 68.823380,160.814453 
	C69.634338,158.888153 70.445305,156.961853 71.425400,154.832001 
	C71.425400,154.832001 71.414757,154.567566 71.979263,154.164169 
	C73.752403,150.175079 75.525543,146.185989 77.129364,142.048004 
	C77.129364,142.048004 77.257011,142.233871 77.729424,142.005768 
	C77.844543,141.685699 77.959663,141.365646 77.998535,141.007477 
	C77.998535,141.007477 78.063026,141.063675 78.597130,140.689941 
	C80.770805,134.117996 74.883575,135.556763 71.998207,133.998657 
	C71.998207,133.998657 71.970734,134.025482 71.596428,133.484131 
	C70.764145,133.257355 69.931870,133.030594 69.052368,132.950348 
	C69.052368,132.950348 69.148010,132.829712 68.790138,132.249161 
	C60.849667,128.541367 52.909195,124.833588 44.733036,120.888527 
	C44.733036,120.888527 44.412041,120.794670 44.218548,120.019600 
	C45.010582,117.919380 45.426361,115.548317 46.692520,113.789391 
	C48.182301,111.719788 50.409489,110.181000 52.289257,108.357666 
	C52.289257,108.357666 52.334972,108.317291 52.851807,108.151497 
	C53.072960,107.870468 53.294109,107.589432 53.807327,107.253220 
	C53.807327,107.253220 54.010265,107.036041 54.627399,106.966560 
	C55.150826,106.375450 55.674255,105.784348 56.141884,105.018257 
	C56.141884,105.018257 56.156910,105.201286 56.672211,105.103470 
	C56.871479,104.830589 57.070744,104.557716 57.033989,104.025688 
	C57.033989,104.025688 57.265690,104.281586 57.797485,104.130836 
z"
                />
                <path
                  fill="#F69923"
                  opacity="1.000000"
                  stroke="none"
                  d="
M13.476224,170.911118 
	C13.345132,170.492798 13.214039,170.074493 13.358216,169.011108 
	C13.740292,156.570648 13.858722,144.775345 13.951711,132.979843 
	C14.225402,98.262604 14.489006,63.545284 14.756558,28.827997 
	C14.756558,28.827997 14.874666,29.039675 15.137115,28.818581 
	C15.833683,27.314157 16.267801,26.030832 16.701920,24.747505 
	C16.701920,24.747505 17.008333,24.863665 17.199997,24.769863 
	C19.598312,22.123964 21.804968,19.571869 24.011621,17.019772 
	C24.011621,17.019772 24.273006,16.809319 24.805927,16.838345 
	C26.501202,16.156172 27.663555,15.444975 28.825909,14.733778 
	C28.825909,14.733779 29.010885,14.842450 29.348587,14.879311 
	C33.135605,14.596555 36.584370,14.006206 40.034321,13.999210 
	C74.456993,13.929410 108.880371,13.849064 143.302399,14.012762 
	C155.379791,14.070198 167.729248,12.111328 179.279968,17.646618 
	C179.279968,17.646618 179.269424,17.757591 179.231277,18.098339 
	C180.251831,19.125454 181.310516,19.811825 182.369202,20.498196 
	C182.369202,20.498198 182.343002,20.564583 182.359375,20.902447 
	C182.912125,21.496553 183.448471,21.752796 183.984833,22.009037 
	C183.984833,22.009037 184.000610,21.999813 184.012207,22.349344 
	C184.811874,23.686489 185.599960,24.674101 186.388046,25.661716 
	C186.388046,25.661716 186.182098,25.872862 186.198990,26.185650 
	C186.827591,29.221413 187.851608,31.926960 187.967575,34.670883 
	C188.231705,40.919895 188.050186,47.187740 188.049988,53.447929 
	C188.049728,61.946903 187.988403,70.446396 188.060654,78.944763 
	C188.309708,108.238136 188.620926,137.531006 188.836960,166.824570 
	C188.847626,168.270233 188.274963,169.750870 187.813416,171.162750 
	C186.948303,173.808960 185.965530,176.416718 185.031723,179.040466 
	C185.031723,179.040466 185.000565,178.999527 184.673218,179.027206 
	C182.574921,181.052429 180.803986,183.049957 179.033051,185.047485 
	C179.033051,185.047485 178.999237,185.001068 178.694336,185.018753 
	C177.984604,185.476288 177.579758,185.916153 177.174927,186.356018 
	C176.729736,186.621719 176.284546,186.887405 175.161560,187.108276 
	C171.917191,187.622116 169.348526,188.670975 166.784332,188.660141 
	C149.690353,188.587936 132.597427,188.281387 115.503922,188.070862 
	C111.892075,188.026367 108.279221,188.064392 104.884239,188.064392 
	C106.906822,182.562073 108.873543,177.211746 110.840263,171.861404 
	C110.840263,171.861404 110.959290,171.956345 111.208038,171.776688 
	C111.895424,170.275879 112.334068,168.954742 112.772720,167.633591 
	C112.772720,167.633591 112.807899,167.289749 113.261009,167.095779 
	C114.485306,165.689255 115.547943,164.569977 115.971626,163.246216 
	C117.125015,159.642471 119.265724,157.585968 123.194565,157.747803 
	C123.194565,157.747803 122.964691,157.855347 123.148941,158.149902 
	C131.189606,162.269958 139.057922,166.071243 146.899078,169.927765 
	C154.702759,173.765854 157.942108,171.744705 157.943695,162.927139 
	C157.951309,120.664543 157.947601,78.401947 157.941299,36.139347 
	C157.941101,34.810066 158.334473,33.196178 157.732635,32.210732 
	C156.477829,30.156223 154.750656,27.025642 153.085175,26.940956 
	C151.118835,26.840975 149.012589,29.492435 146.966995,30.951067 
	C146.966995,30.951067 147.000000,30.999300 146.646912,31.001507 
	C145.587753,31.748751 144.881683,32.493790 144.175613,33.238823 
	C144.175613,33.238827 144.126358,33.030258 143.831696,33.082130 
	C143.027496,33.760075 142.517960,34.386139 142.008438,35.012203 
	C142.008438,35.012203 142.000000,35.000000 141.688202,35.013439 
	C141.026688,35.472092 140.676987,35.917305 140.327286,36.362514 
	C140.327286,36.362514 140.053802,36.314175 139.828003,36.256798 
	C138.403702,37.468758 137.205231,38.738094 136.006744,40.007431 
	C136.006744,40.007431 136.000000,40.000000 135.689911,40.013512 
	C135.002213,40.454700 134.624603,40.882378 134.246994,41.310055 
	C134.246994,41.310055 133.992432,41.190266 133.847198,41.245811 
	C133.533417,41.608578 133.364853,41.915794 133.196289,42.223007 
	C133.196289,42.223007 133.003128,42.066189 132.838577,42.164841 
	C132.478363,42.552223 132.282700,42.840958 132.087036,43.129692 
	C132.087036,43.129692 132.035202,43.003208 131.747345,43.047310 
	C130.964630,43.706787 130.469772,44.322163 129.974930,44.937534 
	C129.974930,44.937534 129.756516,45.177197 129.229340,45.166340 
	C127.461067,46.426029 126.219994,47.696575 124.978912,48.967117 
	C124.978912,48.967117 124.780495,49.198936 124.321411,49.242630 
	C123.655075,49.613071 123.447838,49.939819 123.240601,50.266567 
	C123.240601,50.266567 123.221245,50.303867 122.886559,50.231644 
	C121.704300,51.111626 120.856728,52.063831 120.009148,53.016033 
	C120.009148,53.016033 120.000000,52.999542 119.691582,53.013191 
	C119.026070,53.467823 118.668983,53.908806 118.311890,54.349789 
	C118.311890,54.349789 118.029572,54.322311 117.812988,54.262981 
	C115.816933,55.903717 114.037460,57.603783 112.257988,59.303848 
	C112.257988,59.303848 112.139107,59.221638 111.845795,59.190178 
	C110.712814,60.121628 109.873146,61.084541 109.033478,62.047455 
	C109.033478,62.047451 108.998123,62.002464 108.701965,62.020325 
	C108.020798,62.464615 107.635796,62.891048 107.250793,63.317482 
	C107.250793,63.317482 107.304146,63.091171 106.932709,63.129402 
	C105.720856,64.140999 104.880447,65.114365 104.040047,66.087738 
	C103.937386,66.410263 103.739639,66.656395 102.855042,66.897095 
	C100.850517,68.324547 99.437775,69.681030 98.025032,71.037506 
	C98.025032,71.037506 97.998764,71.000717 97.773613,71.083282 
	C97.364952,71.441826 97.181450,71.717819 96.997948,71.993813 
	C96.997948,71.993813 97.000000,72.000000 96.633560,71.989990 
	C94.844856,73.318672 93.422600,74.657364 92.000343,75.996056 
	C91.281845,76.653786 90.563347,77.311516 89.209198,78.038437 
	C87.705521,79.036888 86.837494,79.966164 85.969467,80.895439 
	C85.969467,80.895439 85.742996,81.149467 85.214119,81.145844 
	C83.238235,82.548210 81.791237,83.954193 80.344231,85.360184 
	C80.344231,85.360184 80.101593,85.276924 79.854134,85.238068 
	C78.405968,86.475945 77.205254,87.752678 76.004539,89.029411 
	C76.004539,89.029411 75.805946,89.250130 75.346458,89.276352 
	C74.682571,89.631851 74.478165,89.961128 74.273766,90.290413 
	C74.273766,90.290413 74.201942,90.341805 73.890808,90.258774 
	C72.537758,91.257256 71.495857,92.338768 70.453949,93.420273 
	C70.453949,93.420273 70.378685,93.395790 70.082413,93.391388 
	C69.664238,93.706551 69.542336,94.026115 69.420433,94.345688 
	C69.420433,94.345688 69.347252,94.343597 69.048569,94.344849 
	C68.581284,94.652283 68.412674,94.958466 68.244064,95.264648 
	C68.244064,95.264648 67.981071,95.152878 67.834930,95.217285 
	C67.512383,95.587593 67.335976,95.893501 67.159576,96.199409 
	C67.159569,96.199409 67.071457,95.986649 66.789246,96.055634 
	C65.996651,96.738228 65.486259,97.351822 64.975868,97.965416 
	C64.975868,97.965416 65.000000,98.000305 64.624016,97.989655 
	C62.498005,99.652023 60.747978,101.325043 58.997955,102.998070 
	C58.997959,102.998070 58.792419,103.224258 58.331299,103.259048 
	C57.668678,103.623093 57.467182,103.952339 57.265686,104.281586 
	C57.265690,104.281586 57.033989,104.025688 56.872673,104.164360 
	C56.526539,104.602448 56.341721,104.901863 56.156906,105.201286 
	C56.156910,105.201286 56.141884,105.018257 55.828728,105.070023 
	C55.013802,105.759880 54.512035,106.397957 54.010265,107.036041 
	C54.010265,107.036041 53.807327,107.253220 53.347900,107.280075 
	C52.703972,107.643715 52.519470,107.980507 52.334972,108.317291 
	C52.334972,108.317291 52.289257,108.357666 51.941620,108.281265 
	C48.871872,110.186302 45.857018,111.877098 43.515148,114.236031 
	C41.433887,116.332451 40.620270,119.092567 44.412041,120.794670 
	C44.412041,120.794670 44.733036,120.888527 44.898472,121.358788 
	C45.725636,122.505348 46.268280,123.422356 47.068691,123.818329 
	C51.755512,126.136978 56.445129,128.468765 61.252972,130.516296 
	C63.758617,131.583374 66.508461,132.077042 69.148010,132.829712 
	C69.148010,132.829712 69.052368,132.950348 69.224777,133.184113 
	C70.255043,133.620422 71.112892,133.822952 71.970734,134.025482 
	C71.970734,134.025482 71.998207,133.998657 72.042969,134.363785 
	C73.286591,137.588409 78.908806,136.275558 78.063026,141.063675 
	C78.063026,141.063675 77.998535,141.007477 77.786438,141.130249 
	C77.468567,141.579971 77.362793,141.906921 77.257011,142.233871 
	C77.257011,142.233871 77.129364,142.048004 76.875809,142.225159 
	C74.886421,146.457397 73.150589,150.512482 71.414757,154.567566 
	C71.414757,154.567566 71.425400,154.832001 71.012604,155.098572 
	C69.816666,157.306396 69.033531,159.247635 68.250397,161.188873 
	C68.250404,161.188873 68.061203,160.981888 67.829285,161.186447 
	C65.542824,166.119873 63.488270,170.848724 61.433716,175.577591 
	C61.433712,175.577591 61.433361,175.843063 61.019951,176.092148 
	C59.788467,177.569839 58.581985,178.693405 58.216675,180.044434 
	C56.166691,187.625885 50.701180,189.673096 43.765804,188.914291 
	C37.455769,188.223923 31.199669,187.040558 24.919794,186.074509 
	C24.919794,186.074509 24.992861,186.009109 24.863960,185.741821 
	C23.818747,184.985474 22.902430,184.496414 21.986113,184.007355 
	C21.666477,183.915665 21.406347,183.737228 21.102135,182.881989 
	C19.885231,181.325729 18.771917,180.359528 17.658606,179.393326 
	C17.658607,179.393326 17.671051,179.327332 17.741066,178.936539 
	C16.366131,176.000870 14.921176,173.455994 13.476224,170.911118 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M147.316162,30.905510 
	C149.012589,29.492435 151.118835,26.840975 153.085175,26.940956 
	C154.750656,27.025642 156.477829,30.156223 157.732635,32.210732 
	C158.334473,33.196178 157.941101,34.810066 157.941299,36.139347 
	C157.947601,78.401947 157.951309,120.664543 157.943695,162.927139 
	C157.942108,171.744705 154.702759,173.765854 146.899078,169.927765 
	C139.057922,166.071243 131.189606,162.269958 123.260582,158.086685 
	C131.386978,161.341629 139.609238,164.902817 147.777542,168.583710 
	C154.070862,171.419693 155.918549,170.335678 155.922318,163.389984 
	C155.945511,120.780754 155.962906,78.171448 155.864471,35.562435 
	C155.859146,33.254608 154.793335,30.949230 154.221191,28.642708 
	C152.035904,29.381788 149.850616,30.120871 147.316162,30.905510 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M179.128967,17.350090 
	C167.729248,12.111328 155.379791,14.070198 143.302399,14.012762 
	C108.880371,13.849064 74.456993,13.929410 40.034321,13.999210 
	C36.584370,14.006206 33.135605,14.596555 29.255173,14.833150 
	C31.769661,13.909879 34.712391,12.349524 37.661293,12.337758 
	C79.630257,12.170309 121.601532,12.045947 163.567734,12.418155 
	C168.717789,12.463832 173.841858,15.437027 179.128967,17.350090 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M185.351883,178.899368 
	C185.965530,176.416718 186.948303,173.808960 187.813416,171.162750 
	C188.274963,169.750870 188.847626,168.270233 188.836960,166.824570 
	C188.620926,137.531006 188.309708,108.238136 188.060654,78.944763 
	C187.988403,70.446396 188.049728,61.946903 188.049988,53.447929 
	C188.050186,47.187740 188.231705,40.919895 187.967575,34.670883 
	C187.851608,31.926960 186.827591,29.221413 186.319458,26.100571 
	C187.647171,29.566961 189.911774,33.424755 189.935837,37.296474 
	C190.199875,79.778351 190.252670,122.263451 189.928619,164.744354 
	C189.892914,169.426208 187.156097,174.087463 185.351883,178.899368 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M14.455164,29.039106 
	C14.489006,63.545284 14.225402,98.262604 13.951711,132.979843 
	C13.858722,144.775345 13.740292,156.570648 13.366697,168.680206 
	C12.794291,166.543213 12.225419,164.092377 12.222331,161.640823 
	C12.171618,121.393471 12.138860,81.145836 12.282160,40.898914 
	C12.295992,37.013844 13.501466,33.133015 14.455164,29.039106 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M110.557190,172.049484 
	C108.873543,177.211746 106.906822,182.562073 104.884239,188.064392 
	C108.279221,188.064392 111.892075,188.026367 115.503922,188.070862 
	C132.597427,188.281387 149.690353,188.587936 166.784332,188.660141 
	C169.348526,188.670975 171.917191,187.622116 174.896942,187.131912 
	C172.383820,188.149323 169.467712,189.883179 166.529633,189.921234 
	C145.807159,190.189636 125.080177,190.111877 104.354622,190.125381 
	C103.880447,190.125687 103.406128,189.899780 101.934525,189.526230 
	C104.781456,183.624313 107.527779,177.930939 110.557190,172.049484 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M25.101009,186.380981 
	C31.199669,187.040558 37.455769,188.223923 43.765804,188.914291 
	C50.701180,189.673096 56.166691,187.625885 58.216675,180.044434 
	C58.581985,178.693405 59.788467,177.569839 60.928963,176.188812 
	C59.518597,180.114365 57.847710,184.220779 55.998936,188.245499 
	C55.644466,189.017181 54.569534,190.011032 53.862110,189.983978 
	C44.256580,189.616562 34.302460,192.087921 25.101009,186.380981 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M68.969070,132.539429 
	C66.508461,132.077042 63.758617,131.583374 61.252972,130.516296 
	C56.445129,128.468765 51.755512,126.136978 47.068691,123.818329 
	C46.268280,123.422356 45.725636,122.505348 45.016315,121.477417 
	C52.909195,124.833588 60.849667,128.541367 68.969070,132.539429 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M44.315292,120.407135 
	C40.620270,119.092567 41.433887,116.332451 43.515148,114.236031 
	C45.857018,111.877098 48.871872,110.186302 51.955444,108.308449 
	C50.409489,110.181000 48.182301,111.719788 46.692520,113.789391 
	C45.426361,115.548317 45.010582,117.919380 44.315292,120.407135 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M123.022675,157.467331 
	C119.265724,157.585968 117.125015,159.642471 115.971626,163.246216 
	C115.547943,164.569977 114.485306,165.689255 113.365692,166.958267 
	C114.016251,164.439560 115.100380,161.893524 115.994316,159.282394 
	C117.344307,155.339142 119.528183,154.493530 123.022675,157.467331 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M61.711182,175.373230 
	C63.488270,170.848724 65.542824,166.119873 67.933441,161.280518 
	C66.175896,165.836319 64.082268,170.502594 61.711182,175.373230 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M71.697006,154.365875 
	C73.150589,150.512482 74.886421,146.457397 76.960472,142.299606 
	C75.525543,146.185989 73.752403,150.175079 71.697006,154.365875 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M23.670326,17.047865 
	C21.804968,19.571869 19.598312,22.123964 17.045322,24.720432 
	C18.909000,22.201855 21.119015,19.638906 23.670326,17.047865 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M78.330078,140.876801 
	C78.908806,136.275558 73.286591,137.588409 72.033646,134.379913 
	C74.883575,135.556763 80.770805,134.117996 78.330078,140.876801 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M13.402632,171.259460 
	C14.921176,173.455994 16.366131,176.000870 17.710995,178.921616 
	C16.183619,176.734253 14.756330,174.171021 13.402632,171.259460 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M179.373154,185.017029 
	C180.803986,183.049957 182.574921,181.052429 184.694336,179.041992 
	C183.266281,181.014923 181.489777,183.000748 179.373154,185.017029 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M112.593071,59.249222 
	C114.037460,57.603783 115.816933,55.903717 117.951454,54.294132 
	C116.513710,55.987942 114.720932,57.591270 112.593071,59.249222 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M59.329998,102.954803 
	C60.747978,101.325043 62.498005,99.652023 64.607071,97.976830 
	C63.198082,99.620285 61.430061,101.265907 59.329998,102.954803 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M98.351341,70.987846 
	C99.437775,69.681030 100.850517,68.324547 102.627960,66.978424 
	C101.554337,68.305260 100.115997,69.621727 98.351341,70.987846 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M92.327927,75.953499 
	C93.422600,74.657364 94.844856,73.318672 96.630653,71.988480 
	C95.547958,73.301636 94.101730,74.606285 92.327927,75.953499 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M80.670822,85.291458 
	C81.791237,83.954193 83.238235,82.548210 85.052589,81.199356 
	C83.945763,82.578568 82.471588,83.900650 80.670822,85.291458 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M68.536888,161.001663 
	C69.033531,159.247635 69.816666,157.306396 70.928040,155.200348 
	C70.445305,156.961853 69.634338,158.888153 68.536888,161.001663 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M125.309807,48.927769 
	C126.219994,47.696575 127.461067,46.426029 129.073975,45.212673 
	C128.177429,46.476051 126.909065,47.682236 125.309807,48.927769 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M76.332016,88.984146 
	C77.205254,87.752678 78.405968,86.475945 79.963715,85.304733 
	C79.100334,86.586456 77.879906,87.762665 76.332016,88.984146 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M136.331024,39.959312 
	C137.205231,38.738094 138.403702,37.468758 139.959137,36.302483 
	C139.095810,37.574093 137.875549,38.742641 136.331024,39.959312 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M17.718021,179.711014 
	C18.771917,180.359528 19.885231,181.325729 20.988342,182.670807 
	C19.911240,182.042694 18.844339,181.035706 17.718021,179.711014 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M70.767593,93.360336 
	C71.495857,92.338768 72.537758,91.257256 73.934952,90.259140 
	C73.220573,91.328491 72.150902,92.314438 70.767593,93.360336 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M86.292358,80.867844 
	C86.837494,79.966164 87.705521,79.036888 88.929741,78.138214 
	C88.395706,79.059288 87.505486,79.949760 86.292358,80.867844 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M120.328445,52.977657 
	C120.856728,52.063831 121.704300,51.111626 122.907600,50.232021 
	C122.391464,51.182842 121.519600,52.061062 120.328445,52.977657 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M104.359100,66.032051 
	C104.880447,65.114365 105.720856,64.140999 106.922226,63.245415 
	C106.414833,64.207588 105.546486,65.091972 104.359100,66.032051 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M109.350372,62.002197 
	C109.873146,61.084541 110.712814,60.121628 111.909393,59.238190 
	C111.399956,60.197430 110.533607,61.077187 109.350372,62.002197 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M182.288223,20.202499 
	C181.310516,19.811825 180.251831,19.125454 179.273132,18.061535 
	C180.304504,18.424923 181.255875,19.165865 182.288223,20.202499 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M28.470457,14.729771 
	C27.663555,15.444975 26.501202,16.156172 24.971481,16.811033 
	C25.774408,16.078386 26.944708,15.402075 28.470457,14.729771 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M16.394180,24.890690 
	C16.267801,26.030832 15.833683,27.314157 15.069094,28.716576 
	C15.187894,27.568401 15.637166,26.301138 16.394180,24.890690 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M186.347443,25.339340 
	C185.599960,24.674101 184.811874,23.686489 184.007324,22.357161 
	C184.762848,23.015951 185.534836,24.016459 186.347443,25.339340 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M112.495285,167.848022 
	C112.334068,168.954742 111.895424,170.275879 111.136139,171.751648 
	C111.282951,170.625000 111.750404,169.343719 112.495285,167.848022 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M22.099346,184.306656 
	C22.902430,184.496414 23.818747,184.985474 24.841763,185.785538 
	C24.036505,185.599686 23.124542,185.102814 22.099346,184.306656 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M144.488220,33.187923 
	C144.881683,32.493790 145.587753,31.748751 146.623413,30.984182 
	C146.235596,31.688774 145.518219,32.412899 144.488220,33.187923 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M54.318832,107.001297 
	C54.512035,106.397957 55.013802,105.759880 55.856625,105.157516 
	C55.674255,105.784348 55.150826,106.375450 54.318832,107.001297 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M142.314865,34.977859 
	C142.517960,34.386139 143.027496,33.760075 143.877960,33.178787 
	C143.686356,33.796883 143.153824,34.370201 142.314865,34.977859 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M65.264160,97.898369 
	C65.486259,97.351822 65.996651,96.738228 66.842430,96.158684 
	C66.636032,96.738937 66.094238,97.285133 65.264160,97.898369 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M71.783585,133.754807 
	C71.112892,133.822952 70.255043,133.620422 69.248390,133.110855 
	C69.931870,133.030594 70.764145,133.257355 71.783585,133.754807 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M130.264496,44.879128 
	C130.469772,44.322163 130.964630,43.706787 131.788574,43.101837 
	C131.596481,43.681744 131.075272,44.251232 130.264496,44.879128 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M183.907074,21.731049 
	C183.448471,21.752796 182.912125,21.496553 182.390778,20.919395 
	C182.880295,20.883339 183.354797,21.168198 183.907074,21.731049 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M177.477203,186.308014 
	C177.579758,185.916153 177.984604,185.476288 178.716705,185.036606 
	C178.622467,185.444519 178.200974,185.852280 177.477203,186.308014 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M140.610168,36.307816 
	C140.676987,35.917305 141.026688,35.472092 141.693909,35.018093 
	C141.638626,35.423908 141.265839,35.838509 140.610168,36.307816 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M134.538147,41.266087 
	C134.624603,40.882378 135.002213,40.454700 135.693268,40.017075 
	C135.614243,40.412125 135.221786,40.817120 134.538147,41.266087 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M107.544022,63.277920 
	C107.635796,62.891048 108.020798,62.464615 108.724838,62.037079 
	C108.641663,62.436768 108.239449,62.837563 107.544022,63.277920 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M118.596329,54.297653 
	C118.668983,53.908806 119.026070,53.467823 119.699432,53.018661 
	C119.637390,53.422165 119.259079,53.833839 118.596329,54.297653 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M77.493217,142.119812 
	C77.362793,141.906921 77.468567,141.579971 77.824562,141.149292 
	C77.959663,141.365646 77.844543,141.685699 77.493217,142.119812 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M133.442825,42.155579 
	C133.364853,41.915794 133.533417,41.608578 133.981262,41.288292 
	C134.070175,41.546200 133.879761,41.817173 133.442825,42.155579 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M132.348053,43.077766 
	C132.282700,42.840958 132.478363,42.552223 132.944672,42.229717 
	C133.013245,42.472580 132.811172,42.749214 132.348053,43.077766 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M123.514427,50.200775 
	C123.447838,49.939819 123.655075,49.613071 124.173325,49.279388 
	C124.252304,49.559967 124.020279,49.847473 123.514427,50.200775 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M68.485573,95.213593 
	C68.412674,94.958466 68.581284,94.652283 69.032402,94.377701 
	C69.245026,94.758713 69.049080,95.009796 68.485573,95.213593 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M97.250954,71.934189 
	C97.181450,71.717819 97.364952,71.441826 97.793594,71.093697 
	C97.860481,71.305893 97.682220,71.590233 97.250954,71.934189 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M74.541397,90.217339 
	C74.478165,89.961128 74.682571,89.631851 75.200806,89.305016 
	C75.279427,89.586395 75.044220,89.865326 74.541397,90.217339 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M52.593391,108.234390 
	C52.519470,107.980507 52.703972,107.643715 53.201866,107.307663 
	C53.294109,107.589432 53.072960,107.870468 52.593391,108.234390 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M56.414558,105.152374 
	C56.341721,104.901863 56.526539,104.602448 56.990685,104.293938 
	C57.070744,104.557716 56.871479,104.830589 56.414558,105.152374 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M57.531586,104.206207 
	C57.467182,103.952339 57.668678,103.623093 58.182396,103.293411 
	C58.262238,103.572258 58.029861,103.851547 57.531586,104.206207 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M69.642593,94.283173 
	C69.542336,94.026115 69.664238,93.706551 70.069885,93.428925 
	C70.314125,93.801277 70.151161,94.051208 69.642593,94.283173 
z"
                />
                <path
                  fill="#EDA952"
                  opacity="1.000000"
                  stroke="none"
                  d="
M67.415482,96.140762 
	C67.335976,95.893501 67.512383,95.587593 67.968605,95.263626 
	C68.056076,95.524422 67.863731,95.803276 67.415482,96.140762 
z"
                />
              </svg>
              <p style={{ fontWeight: "bold", fontSize: "2rem" }}>
                Alt Shift Creative
              </p>
              <div className="project-links">
                <a
                  href="https://www.altshiftcreative.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Junior Full Stack Developer</h3>
              <p>
                At Alt Shift Creative, I worked as a full-stack developer using
                Angular and Java. I contributed to various projects, including
                an IoT-based solution and a food delivery application, gaining
                experience in diverse technologies and real-world applications.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
              <li>August 2, 2020</li> <li>⟶</li> <li>April 1, 2021</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}
